// SoumissionPro - Catalogue exhaustif de matériaux par type de travaux
// Prix de base indicatifs CAD (2025), moyennes Home Depot / Rona / Patrick Morin / Lowe's
// L'IA Claude ajuste les prix à la province quand connecté.

const FR = {
  'Rénovation cuisine': [
    { name: 'Armoire mélamine standard', unit: 'pi.lin.', price: 180 },
    { name: 'Armoire MDF thermoplastique', unit: 'pi.lin.', price: 240 },
    { name: 'Armoire bois massif', unit: 'pi.lin.', price: 380 },
    { name: 'Armoire sur mesure haut de gamme', unit: 'pi.lin.', price: 520 },
    { name: 'Caisson d\'armoire bas (cabinet)', unit: 'un', price: 145 },
    { name: 'Caisson d\'armoire haut', unit: 'un', price: 110 },
    { name: 'Façade de tiroir', unit: 'un', price: 38 },
    { name: 'Mécanisme tiroir Blum', unit: 'un', price: 42 },
    { name: 'Charnière à fermeture lente', unit: 'un', price: 8 },
    { name: 'Poignée armoire métal', unit: 'un', price: 6 },
    { name: 'Bouton armoire', unit: 'un', price: 4 },
    { name: 'Comptoir stratifié (Arborite)', unit: 'pi.lin.', price: 65 },
    { name: 'Comptoir quartz', unit: 'pi.²', price: 95 },
    { name: 'Comptoir granit', unit: 'pi.²', price: 85 },
    { name: 'Comptoir bois bloc boucher', unit: 'pi.²', price: 55 },
    { name: 'Comptoir béton sur mesure', unit: 'pi.²', price: 110 },
    { name: 'Dosseret céramique', unit: 'pi.²', price: 18 },
    { name: 'Dosseret verre trempé', unit: 'pi.²', price: 38 },
    { name: 'Dosseret inox', unit: 'pi.²', price: 28 },
    { name: 'Dosseret marbre', unit: 'pi.²', price: 45 },
    { name: 'Évier inox simple', unit: 'un', price: 220 },
    { name: 'Évier inox double', unit: 'un', price: 280 },
    { name: 'Évier sous comptoir', unit: 'un', price: 380 },
    { name: 'Évier en granit composite', unit: 'un', price: 450 },
    { name: 'Robinet cuisine standard', unit: 'un', price: 220 },
    { name: 'Robinet cuisine col-de-cygne', unit: 'un', price: 320 },
    { name: 'Robinet à douchette extractible', unit: 'un', price: 380 },
    { name: 'Distributeur de savon encastré', unit: 'un', price: 45 },
    { name: 'Hotte de cuisinière 30"', unit: 'un', price: 350 },
    { name: 'Hotte de cuisinière 36"', unit: 'un', price: 480 },
    { name: 'Hotte îlot suspendue', unit: 'un', price: 950 },
    { name: 'Cuisinière électrique', unit: 'un', price: 1200 },
    { name: 'Cuisinière à gaz', unit: 'un', price: 1850 },
    { name: 'Réfrigérateur 2 portes', unit: 'un', price: 1850 },
    { name: 'Lave-vaisselle encastré', unit: 'un', price: 950 },
    { name: 'Micro-ondes encastré', unit: 'un', price: 480 },
    { name: 'Îlot de cuisine standard', unit: 'un', price: 1800 },
    { name: 'Îlot avec rangement', unit: 'un', price: 2800 },
    { name: 'Tablette ouverte (chêne)', unit: 'pi.lin.', price: 32 },
    { name: 'Garde-manger encastré', unit: 'un', price: 850 },
    { name: 'Plinthes MDF', unit: 'pi.lin.', price: 2.50 },
    { name: 'Quart-de-rond MDF', unit: 'pi.lin.', price: 1.50 },
    { name: 'Éclairage sous armoire DEL', unit: 'pi.lin.', price: 18 },
    { name: 'Tabouret îlot', unit: 'un', price: 145 },
  ],
  'Rénovation salle de bain': [
    { name: 'Vanité 18"', unit: 'un', price: 320 },
    { name: 'Vanité 24"', unit: 'un', price: 450 },
    { name: 'Vanité 30"', unit: 'un', price: 580 },
    { name: 'Vanité 36"', unit: 'un', price: 720 },
    { name: 'Vanité 48"', unit: 'un', price: 950 },
    { name: 'Vanité 60" double', unit: 'un', price: 1450 },
    { name: 'Vanité flottante sur mesure', unit: 'pi.lin.', price: 380 },
    { name: 'Comptoir vanité quartz', unit: 'pi.lin.', price: 110 },
    { name: 'Comptoir vanité granit', unit: 'pi.lin.', price: 95 },
    { name: 'Lavabo encastré porcelaine', unit: 'un', price: 145 },
    { name: 'Lavabo vasque sur comptoir', unit: 'un', price: 280 },
    { name: 'Toilette standard ronde', unit: 'un', price: 220 },
    { name: 'Toilette allongée standard', unit: 'un', price: 280 },
    { name: 'Toilette double chasse', unit: 'un', price: 420 },
    { name: 'Toilette suspendue (avec réservoir)', unit: 'un', price: 850 },
    { name: 'Toilette intelligente bidet', unit: 'un', price: 1850 },
    { name: 'Bain en acrylique standard', unit: 'un', price: 650 },
    { name: 'Bain encastré 60"', unit: 'un', price: 850 },
    { name: 'Bain podium ovale', unit: 'un', price: 1850 },
    { name: 'Bain autoportant', unit: 'un', price: 2200 },
    { name: 'Bain tourbillon (whirlpool)', unit: 'un', price: 2800 },
    { name: 'Base de douche acrylique 32x32', unit: 'un', price: 320 },
    { name: 'Base de douche acrylique 36x60', unit: 'un', price: 480 },
    { name: 'Base de douche céramique sur mesure', unit: 'pi.²', price: 28 },
    { name: 'Douche en céramique sur mesure (parois)', unit: 'pi.²', price: 45 },
    { name: 'Porte de douche pivotante', unit: 'un', price: 580 },
    { name: 'Porte de douche coulissante', unit: 'un', price: 750 },
    { name: 'Porte de douche sans cadre verre 10mm', unit: 'un', price: 1450 },
    { name: 'Robinet de bain mural', unit: 'un', price: 280 },
    { name: 'Robinet de douche thermostatique', unit: 'un', price: 480 },
    { name: 'Pomme de douche standard', unit: 'un', price: 65 },
    { name: 'Pomme de douche pluie 8"', unit: 'un', price: 220 },
    { name: 'Barre de douche réglable', unit: 'un', price: 145 },
    { name: 'Robinet vanité (mitigeur)', unit: 'un', price: 180 },
    { name: 'Céramique au sol 12x12', unit: 'pi.²', price: 8 },
    { name: 'Porcelaine grand format au sol', unit: 'pi.²', price: 12 },
    { name: 'Mosaïque verre/marbre', unit: 'pi.²', price: 22 },
    { name: 'Plancher chauffant électrique', unit: 'pi.²', price: 12 },
    { name: 'Membrane d\'imperméabilisation', unit: 'pi.²', price: 4.50 },
    { name: 'Mortier à céramique', unit: 'sac', price: 28 },
    { name: 'Coulis sablé 5 lb', unit: 'sac', price: 18 },
    { name: 'Ventilateur de salle de bain 80 CFM', unit: 'un', price: 95 },
    { name: 'Ventilateur silencieux 110 CFM', unit: 'un', price: 165 },
    { name: 'Miroir biseauté', unit: 'un', price: 180 },
    { name: 'Miroir avec éclairage DEL', unit: 'un', price: 380 },
    { name: 'Pharmacie encastrée', unit: 'un', price: 280 },
    { name: 'Luminaire vanité 3 lumières', unit: 'un', price: 165 },
    { name: 'Plafonnier DEL salle de bain', unit: 'un', price: 95 },
    { name: 'Porte-serviettes mural', unit: 'un', price: 38 },
    { name: 'Porte-papier hygiénique', unit: 'un', price: 22 },
    { name: 'Barre d\'appui sécurité', unit: 'un', price: 45 },
  ],
  'Toiture': [
    { name: 'Bardeau d\'asphalte 3-pattes 20 ans', unit: 'paquet', price: 28 },
    { name: 'Bardeau d\'asphalte 25 ans', unit: 'paquet', price: 38 },
    { name: 'Bardeau architectural 30 ans', unit: 'paquet', price: 48 },
    { name: 'Bardeau architectural 50 ans', unit: 'paquet', price: 65 },
    { name: 'Bardeau de cèdre', unit: 'paquet', price: 145 },
    { name: 'Bardeau métallique (acier galvanisé)', unit: 'pi.²', price: 7 },
    { name: 'Tôle d\'acier nervurée', unit: 'pi.²', price: 4.50 },
    { name: 'Tôle d\'acier prépeinte', unit: 'pi.²', price: 6.50 },
    { name: 'Tôle profilée à joint debout', unit: 'pi.²', price: 12 },
    { name: 'Membrane élastomère sablée', unit: 'rouleau', price: 145 },
    { name: 'Membrane élastomère granulée', unit: 'rouleau', price: 165 },
    { name: 'Membrane TPO blanche', unit: 'pi.²', price: 4.50 },
    { name: 'Membrane EPDM', unit: 'pi.²', price: 3.80 },
    { name: 'Sous-couche feutre #15', unit: 'rouleau', price: 38 },
    { name: 'Sous-couche feutre #30', unit: 'rouleau', price: 52 },
    { name: 'Sous-couche synthétique', unit: 'rouleau', price: 95 },
    { name: 'Sous-couche autocollante (Ice & Water)', unit: 'rouleau', price: 165 },
    { name: 'Larmier en aluminium', unit: 'pi.lin.', price: 3.20 },
    { name: 'Larmier en acier galvanisé', unit: 'pi.lin.', price: 2.80 },
    { name: 'Solin de cheminée préfab', unit: 'un', price: 85 },
    { name: 'Solin métallique au pied', unit: 'pi.lin.', price: 4.50 },
    { name: 'Solin de mur', unit: 'pi.lin.', price: 5.50 },
    { name: 'Évent de toit standard', unit: 'un', price: 38 },
    { name: 'Évent de toit Maximum', unit: 'un', price: 65 },
    { name: 'Évent faîtière (rouleau)', unit: 'pi.lin.', price: 7.50 },
    { name: 'Évent de salle de bain', unit: 'un', price: 28 },
    { name: 'Évent de sécheuse', unit: 'un', price: 22 },
    { name: 'Cheminée renforcée', unit: 'un', price: 280 },
    { name: 'Soffite vinyle', unit: 'pi.²', price: 2.20 },
    { name: 'Soffite aluminium', unit: 'pi.²', price: 3.50 },
    { name: 'Fascia aluminium', unit: 'pi.lin.', price: 4 },
    { name: 'Gouttière aluminium 5"', unit: 'pi.lin.', price: 6 },
    { name: 'Descente pluviale', unit: 'pi.lin.', price: 5 },
    { name: 'Filet protège-gouttière', unit: 'pi.lin.', price: 4.50 },
    { name: 'Contreplaqué 1/2" pour toiture', unit: 'feuille', price: 42 },
    { name: 'Contreplaqué 5/8" pour toiture', unit: 'feuille', price: 52 },
    { name: 'OSB 5/8" toiture', unit: 'feuille', price: 38 },
    { name: 'Clous de toiture galv. 1¼"', unit: 'lb', price: 4.50 },
    { name: 'Clous de toiture galv. 1½"', unit: 'lb', price: 5 },
    { name: 'Vis à toiture métallique', unit: 'lb', price: 12 },
    { name: 'Scellant de toiture (Mulehide)', unit: 'tube', price: 12 },
    { name: 'Goudron à toiture', unit: 'gallon', price: 35 },
    { name: 'Pare-neige (snow stop)', unit: 'un', price: 18 },
    { name: 'Échafaudage location/jour', unit: 'jour', price: 95 },
    { name: 'Conteneur 14 vg.³ pour vieux bardeaux', unit: 'un', price: 380 },
  ],
  'Revêtement extérieur': [
    { name: 'Bardage vinyle entrée de gamme', unit: 'pi.²', price: 2.50 },
    { name: 'Bardage vinyle premium', unit: 'pi.²', price: 4.50 },
    { name: 'Bardage en fibrociment (Hardie)', unit: 'pi.²', price: 6.50 },
    { name: 'Bardage de cèdre (clins)', unit: 'pi.²', price: 9 },
    { name: 'Bardage de cèdre rouge', unit: 'pi.²', price: 12 },
    { name: 'Bardage en pin traité', unit: 'pi.²', price: 5 },
    { name: 'Bardage en aluminium', unit: 'pi.²', price: 5.80 },
    { name: 'Bardage en acier (Mac Métal)', unit: 'pi.²', price: 8 },
    { name: 'Pierre de parement décorative', unit: 'pi.²', price: 14 },
    { name: 'Brique de parement', unit: 'pi.²', price: 11 },
    { name: 'Stucco acrylique (système)', unit: 'pi.²', price: 9 },
    { name: 'Bois canexel', unit: 'pi.²', price: 7.50 },
    { name: 'Pare-air pare-vapeur (Tyvek)', unit: 'rouleau', price: 145 },
    { name: 'Membrane drainante', unit: 'rouleau', price: 185 },
    { name: 'Isolant rigide R-5 1"', unit: 'feuille', price: 28 },
    { name: 'Isolant rigide R-10 2"', unit: 'feuille', price: 48 },
    { name: 'Isolant graphite R-5', unit: 'feuille', price: 38 },
    { name: 'Tasseaux 1x3 traités', unit: 'pi.lin.', price: 2.20 },
    { name: 'Moulure J-trim vinyle', unit: 'pi.lin.', price: 3.50 },
    { name: 'Coin extérieur vinyle', unit: 'un', price: 8 },
    { name: 'Coin extérieur fibrociment', unit: 'un', price: 18 },
    { name: 'Solin de fenêtre', unit: 'pi.lin.', price: 4 },
    { name: 'Membrane de solin auto-adhésive', unit: 'rouleau', price: 65 },
    { name: 'Calfeutrant silicone extérieur', unit: 'tube', price: 8 },
    { name: 'Clous galvanisés revêtement', unit: 'lb', price: 4 },
    { name: 'Vis structurelles 3"', unit: 'lb', price: 12 },
    { name: 'Échafaudage location/jour', unit: 'jour', price: 95 },
    { name: 'Apprêt extérieur', unit: 'gallon', price: 52 },
    { name: 'Peinture latex extérieur', unit: 'gallon', price: 68 },
    { name: 'Teinture cèdre semi-transparente', unit: 'gallon', price: 65 },
    { name: 'Boîte à lampe extérieure', unit: 'un', price: 12 },
    { name: 'Évent à façade soffite', unit: 'pi.²', price: 1.50 },
    { name: 'Lattes de bois pour rainurage', unit: 'pi.lin.', price: 1.80 },
  ],
  'Plancher': [
    { name: 'Plancher flottant stratifié 8mm', unit: 'pi.²', price: 2.20 },
    { name: 'Plancher flottant stratifié 12mm', unit: 'pi.²', price: 3.50 },
    { name: 'Plancher vinyle (LVT) 4mm', unit: 'pi.²', price: 4.50 },
    { name: 'Plancher vinyle (LVP) 6mm', unit: 'pi.²', price: 6.50 },
    { name: 'Plancher vinyle commercial', unit: 'pi.²', price: 8 },
    { name: 'Bois franc chêne 3/4" rouge', unit: 'pi.²', price: 7.50 },
    { name: 'Bois franc chêne 3/4" blanc', unit: 'pi.²', price: 9 },
    { name: 'Bois franc érable 3/4"', unit: 'pi.²', price: 9 },
    { name: 'Bois franc bouleau jaune', unit: 'pi.²', price: 8.50 },
    { name: 'Bois franc cerisier', unit: 'pi.²', price: 11 },
    { name: 'Bois franc noyer noir', unit: 'pi.²', price: 14 },
    { name: 'Bois d\'ingénierie 5"', unit: 'pi.²', price: 6.50 },
    { name: 'Bois d\'ingénierie 7"', unit: 'pi.²', price: 8.50 },
    { name: 'Bambou stratifié', unit: 'pi.²', price: 5.50 },
    { name: 'Liège naturel', unit: 'pi.²', price: 6 },
    { name: 'Céramique 12x12 standard', unit: 'pi.²', price: 5.50 },
    { name: 'Céramique 18x18', unit: 'pi.²', price: 7 },
    { name: 'Porcelaine 24x24', unit: 'pi.²', price: 9 },
    { name: 'Porcelaine 24x48 grand format', unit: 'pi.²', price: 12 },
    { name: 'Carreaux de marbre', unit: 'pi.²', price: 18 },
    { name: 'Ardoise naturelle', unit: 'pi.²', price: 14 },
    { name: 'Mosaïque hexagonale', unit: 'pi.²', price: 16 },
    { name: 'Tapis berbère bouclé', unit: 'vg.²', price: 32 },
    { name: 'Tapis frisé', unit: 'vg.²', price: 38 },
    { name: 'Tapis commercial', unit: 'vg.²', price: 28 },
    { name: 'Sous-tapis (8 lb)', unit: 'vg.²', price: 8 },
    { name: 'Sous-couche acoustique 2mm', unit: 'pi.²', price: 0.85 },
    { name: 'Sous-couche acoustique 6mm', unit: 'pi.²', price: 1.80 },
    { name: 'Membrane de découplage', unit: 'pi.²', price: 3.80 },
    { name: 'Membrane à tapis chauffant 120V', unit: 'pi.²', price: 3.50 },
    { name: 'Thermostat plancher chauffant', unit: 'un', price: 280 },
    { name: 'Plinthe MDF 4"', unit: 'pi.lin.', price: 2.20 },
    { name: 'Plinthe MDF 6"', unit: 'pi.lin.', price: 3.50 },
    { name: 'Plinthe pin colonial 4"', unit: 'pi.lin.', price: 3.80 },
    { name: 'Quart-de-rond MDF', unit: 'pi.lin.', price: 1.50 },
    { name: 'Moulure de transition T-mold', unit: 'pi.lin.', price: 8 },
    { name: 'Réducteur de hauteur', unit: 'pi.lin.', price: 7 },
    { name: 'Seuil de porte aluminium', unit: 'un', price: 22 },
    { name: 'Colle à bois franc', unit: 'gallon', price: 65 },
    { name: 'Colle à vinyle', unit: 'gallon', price: 48 },
    { name: 'Mortier à céramique gris', unit: 'sac', price: 28 },
    { name: 'Mortier modifié polymère', unit: 'sac', price: 38 },
    { name: 'Coulis sablé 5 lb', unit: 'sac', price: 18 },
    { name: 'Coulis époxy 1 gal', unit: 'kit', price: 145 },
    { name: 'Compensateur de niveau (sac 22kg)', unit: 'sac', price: 32 },
  ],
  'Peinture': [
    { name: 'Peinture latex intérieur économique', unit: 'gallon', price: 38 },
    { name: 'Peinture latex intérieur standard', unit: 'gallon', price: 52 },
    { name: 'Peinture latex intérieur premium', unit: 'gallon', price: 78 },
    { name: 'Peinture latex lavable cuisine/SDB', unit: 'gallon', price: 72 },
    { name: 'Peinture mate antitaches', unit: 'gallon', price: 85 },
    { name: 'Peinture coquille d\'œuf', unit: 'gallon', price: 68 },
    { name: 'Peinture satinée', unit: 'gallon', price: 72 },
    { name: 'Peinture semi-lustrée', unit: 'gallon', price: 75 },
    { name: 'Peinture haute brillance', unit: 'gallon', price: 82 },
    { name: 'Peinture latex extérieur', unit: 'gallon', price: 68 },
    { name: 'Peinture extérieur 100% acrylique', unit: 'gallon', price: 88 },
    { name: 'Peinture pour métal', unit: 'gallon', price: 78 },
    { name: 'Peinture à plancher époxy (kit)', unit: 'kit', price: 145 },
    { name: 'Peinture à clôture', unit: 'gallon', price: 58 },
    { name: 'Peinture pour radiateur', unit: 'litre', price: 28 },
    { name: 'Apprêt scellant universel', unit: 'gallon', price: 45 },
    { name: 'Apprêt à base d\'huile (KILZ)', unit: 'gallon', price: 65 },
    { name: 'Apprêt anti-tâches', unit: 'gallon', price: 72 },
    { name: 'Vernis polyuréthane huile', unit: 'gallon', price: 72 },
    { name: 'Vernis polyuréthane à eau', unit: 'gallon', price: 85 },
    { name: 'Teinture intérieur', unit: 'litre', price: 28 },
    { name: 'Teinture extérieure semi-transparente', unit: 'gallon', price: 58 },
    { name: 'Teinture extérieure opaque', unit: 'gallon', price: 65 },
    { name: 'Pinceau angulaire 2"', unit: 'un', price: 12 },
    { name: 'Pinceau angulaire 2½"', unit: 'un', price: 16 },
    { name: 'Pinceau plat 3"', unit: 'un', price: 18 },
    { name: 'Pinceau premium Wooster', unit: 'un', price: 28 },
    { name: 'Manchon rouleau 9" microfibre', unit: 'un', price: 8 },
    { name: 'Manchon rouleau 9" mousse', unit: 'un', price: 6 },
    { name: 'Manchon rouleau 18" pro', unit: 'un', price: 22 },
    { name: 'Cadre rouleau 9"', unit: 'un', price: 12 },
    { name: 'Plateau peinture standard', unit: 'un', price: 8 },
    { name: 'Plateau peinture pro avec doublure', unit: 'un', price: 18 },
    { name: 'Ruban à masquer 1"', unit: 'rouleau', price: 5 },
    { name: 'Ruban à masquer FrogTape 1.4"', unit: 'rouleau', price: 12 },
    { name: 'Bâche plastique', unit: 'rouleau', price: 18 },
    { name: 'Bâche tissu 9x12', unit: 'un', price: 22 },
    { name: 'Pâte à joints prémélangée 5 gal', unit: 'seau', price: 28 },
    { name: 'Pâte à joints en poudre', unit: 'sac', price: 22 },
    { name: 'Ruban à joints papier', unit: 'rouleau', price: 6 },
    { name: 'Ruban à joints fibre de verre', unit: 'rouleau', price: 10 },
    { name: 'Coin métallique pour gypse', unit: 'pi.lin.', price: 1.20 },
    { name: 'Calfeutrant acrylique blanc', unit: 'tube', price: 5.50 },
    { name: 'Calfeutrant siliconé', unit: 'tube', price: 8.50 },
    { name: 'Bouche-pores à bois', unit: 'tube', price: 7 },
    { name: 'Papier sablé 120 (paquet 5)', unit: 'paquet', price: 12 },
    { name: 'Bloc à sablage', unit: 'un', price: 6 },
    { name: 'Décapant chimique', unit: 'litre', price: 32 },
    { name: 'Diluant à peinture', unit: 'litre', price: 18 },
  ],
  'Électricité': [
    { name: 'Panneau électrique 100A', unit: 'un', price: 210 },
    { name: 'Panneau électrique 200A', unit: 'un', price: 380 },
    { name: 'Panneau 400A résidentiel', unit: 'un', price: 950 },
    { name: 'Sous-panneau 100A', unit: 'un', price: 165 },
    { name: 'Disjoncteur 15A simple', unit: 'un', price: 12 },
    { name: 'Disjoncteur 20A simple', unit: 'un', price: 14 },
    { name: 'Disjoncteur 30A simple', unit: 'un', price: 22 },
    { name: 'Disjoncteur 40A double pôle', unit: 'un', price: 38 },
    { name: 'Disjoncteur 60A double pôle', unit: 'un', price: 52 },
    { name: 'Disjoncteur GFCI 15A', unit: 'un', price: 48 },
    { name: 'Disjoncteur AFCI 15A', unit: 'un', price: 58 },
    { name: 'Disjoncteur combo AFCI/GFCI', unit: 'un', price: 75 },
    { name: 'Câble Romex NMD90 14/2 (75m)', unit: 'rouleau', price: 78 },
    { name: 'Câble Romex NMD90 12/2 (75m)', unit: 'rouleau', price: 95 },
    { name: 'Câble Romex 12/3 (75m)', unit: 'rouleau', price: 145 },
    { name: 'Câble Romex 14/3 (75m)', unit: 'rouleau', price: 125 },
    { name: 'Câble Romex 10/2 (75m)', unit: 'rouleau', price: 165 },
    { name: 'Câble Romex 10/3 (75m)', unit: 'rouleau', price: 195 },
    { name: 'Câble Romex 8/3 (50m)', unit: 'rouleau', price: 285 },
    { name: 'Câble TECK90 12/2 BX', unit: 'pi.lin.', price: 1.80 },
    { name: 'Câble extérieur NMWU 14/2', unit: 'pi.lin.', price: 1.20 },
    { name: 'Boîte électrique simple plastique', unit: 'un', price: 1.50 },
    { name: 'Boîte électrique double plastique', unit: 'un', price: 3.20 },
    { name: 'Boîte électrique octogonale', unit: 'un', price: 2.80 },
    { name: 'Boîte étanche extérieure', unit: 'un', price: 8 },
    { name: 'Prise standard 15A décor', unit: 'un', price: 3.50 },
    { name: 'Prise standard 20A', unit: 'un', price: 8 },
    { name: 'Prise GFCI 15A', unit: 'un', price: 22 },
    { name: 'Prise GFCI 20A', unit: 'un', price: 28 },
    { name: 'Prise USB intégrée', unit: 'un', price: 32 },
    { name: 'Prise sécheuse 30A', unit: 'un', price: 22 },
    { name: 'Prise cuisinière 50A', unit: 'un', price: 28 },
    { name: 'Prise extérieure étanche', unit: 'un', price: 18 },
    { name: 'Interrupteur simple', unit: 'un', price: 3 },
    { name: 'Interrupteur 3 voies', unit: 'un', price: 8 },
    { name: 'Interrupteur 4 voies', unit: 'un', price: 14 },
    { name: 'Gradateur (dimmer)', unit: 'un', price: 28 },
    { name: 'Gradateur DEL compatible', unit: 'un', price: 38 },
    { name: 'Interrupteur intelligent Wi-Fi', unit: 'un', price: 65 },
    { name: 'Détecteur de mouvement', unit: 'un', price: 32 },
    { name: 'Plaque interrupteur simple', unit: 'un', price: 1.50 },
    { name: 'Plaque interrupteur double', unit: 'un', price: 2.50 },
    { name: 'Plaque inox brossé', unit: 'un', price: 8 },
    { name: 'Plafonnier encastré DEL 4"', unit: 'un', price: 22 },
    { name: 'Plafonnier encastré DEL 6"', unit: 'un', price: 32 },
    { name: 'Plafonnier sur rail', unit: 'pi.lin.', price: 28 },
    { name: 'Luminaire suspendu îlot', unit: 'un', price: 280 },
    { name: 'Luminaire mural extérieur', unit: 'un', price: 145 },
    { name: 'Lumière de chemin', unit: 'un', price: 65 },
    { name: 'Détecteur de fumée câblé', unit: 'un', price: 32 },
    { name: 'Détecteur CO câblé', unit: 'un', price: 48 },
    { name: 'Conduit ENT 1/2"', unit: 'pi.lin.', price: 0.85 },
    { name: 'Conduit ENT 3/4"', unit: 'pi.lin.', price: 1.20 },
    { name: 'Conduit RNMC 1/2"', unit: 'pi.lin.', price: 1.50 },
    { name: 'Connecteur Marrette (lot 100)', unit: 'lot', price: 8 },
    { name: 'Borne Wago 5 ports', unit: 'lot', price: 18 },
    { name: 'Ruban électrique', unit: 'rouleau', price: 4 },
    { name: 'Tire-fil', unit: 'un', price: 28 },
    { name: 'Borne de recharge VE 240V', unit: 'un', price: 850 },
    { name: 'Génératrice de secours 9kW', unit: 'un', price: 4500 },
  ],
  'Plomberie': [
    { name: 'Tuyau PEX 1/2" (rouleau 100\')', unit: 'rouleau', price: 78 },
    { name: 'Tuyau PEX 3/4" (rouleau 100\')', unit: 'rouleau', price: 125 },
    { name: 'Tuyau PEX 1" (rouleau 100\')', unit: 'rouleau', price: 195 },
    { name: 'Tuyau cuivre type M 1/2"', unit: 'pi.lin.', price: 4.50 },
    { name: 'Tuyau cuivre type L 1/2"', unit: 'pi.lin.', price: 5.50 },
    { name: 'Tuyau cuivre 3/4" type L', unit: 'pi.lin.', price: 6.50 },
    { name: 'Tuyau cuivre 1" type L', unit: 'pi.lin.', price: 9.50 },
    { name: 'Tuyau ABS 1½"', unit: 'pi.lin.', price: 3.50 },
    { name: 'Tuyau ABS 2"', unit: 'pi.lin.', price: 4.20 },
    { name: 'Tuyau ABS 3"', unit: 'pi.lin.', price: 5.50 },
    { name: 'Tuyau ABS 4"', unit: 'pi.lin.', price: 8 },
    { name: 'Tuyau PVC 4" cédulaire 40', unit: 'pi.lin.', price: 7 },
    { name: 'Tuyau de drainage français 4"', unit: 'pi.lin.', price: 1.85 },
    { name: 'Coude cuivre 1/2" 90°', unit: 'un', price: 1.80 },
    { name: 'Coude cuivre 1/2" 45°', unit: 'un', price: 2.20 },
    { name: 'Coude cuivre 3/4"', unit: 'un', price: 3 },
    { name: 'Coude PEX 1/2" sans plomb', unit: 'un', price: 4.50 },
    { name: 'Coude ABS 1½"', unit: 'un', price: 3 },
    { name: 'Coude ABS 3"', unit: 'un', price: 6 },
    { name: 'Coude ABS 4"', unit: 'un', price: 9 },
    { name: 'Té cuivre 1/2"', unit: 'un', price: 3 },
    { name: 'Té cuivre 3/4"', unit: 'un', price: 4.50 },
    { name: 'Té PEX 1/2"', unit: 'un', price: 6 },
    { name: 'Té ABS 3"', unit: 'un', price: 8 },
    { name: 'Réducteur cuivre 3/4"-1/2"', unit: 'un', price: 2.80 },
    { name: 'Bouchon cuivre', unit: 'un', price: 1.20 },
    { name: 'Manchon ABS', unit: 'un', price: 2 },
    { name: 'Valve d\'arrêt 1/4 tour 1/2"', unit: 'un', price: 18 },
    { name: 'Valve d\'arrêt 3/4"', unit: 'un', price: 28 },
    { name: 'Valve principale 1"', unit: 'un', price: 65 },
    { name: 'Valve à bille laiton 1/2"', unit: 'un', price: 22 },
    { name: 'Valve anti-retour', unit: 'un', price: 38 },
    { name: 'Valve mélangeuse douche', unit: 'un', price: 145 },
    { name: 'Réducteur de pression', unit: 'un', price: 165 },
    { name: 'Adoucisseur d\'eau', unit: 'un', price: 1450 },
    { name: 'Filtre à sédiments', unit: 'un', price: 95 },
    { name: 'Système osmose inversée', unit: 'un', price: 480 },
    { name: 'Chauffe-eau électrique 40 gal', unit: 'un', price: 520 },
    { name: 'Chauffe-eau électrique 60 gal', unit: 'un', price: 720 },
    { name: 'Chauffe-eau au gaz 50 gal', unit: 'un', price: 950 },
    { name: 'Chauffe-eau instantané au gaz', unit: 'un', price: 2200 },
    { name: 'Pompe submersible 1/2 HP', unit: 'un', price: 480 },
    { name: 'Pompe à éjecteur fosse', unit: 'un', price: 380 },
    { name: 'Pompe de puits 3/4 HP', unit: 'un', price: 680 },
    { name: 'Réservoir à pression', unit: 'un', price: 280 },
    { name: 'Drain de plancher 4"', unit: 'un', price: 65 },
    { name: 'Drain linéaire douche', unit: 'un', price: 280 },
    { name: 'Avaloir de sol fonte', unit: 'un', price: 145 },
    { name: 'Renvoi en P', unit: 'un', price: 18 },
    { name: 'Évent de toiture plomberie', unit: 'un', price: 38 },
    { name: 'Soudure à l\'argent (rouleau)', unit: 'rouleau', price: 28 },
    { name: 'Pâte à souder', unit: 'pot', price: 12 },
    { name: 'Téflon ruban', unit: 'rouleau', price: 4 },
    { name: 'Pâte à joint plombier', unit: 'tube', price: 8 },
    { name: 'Colle ABS', unit: 'pot', price: 12 },
    { name: 'Colle PVC', unit: 'pot', price: 14 },
    { name: 'Apprêt PVC violet', unit: 'pot', price: 12 },
    { name: 'Joint torique (lot)', unit: 'lot', price: 6 },
    { name: 'Garniture toilette (boulons + cire)', unit: 'kit', price: 15 },
  ],
  'Charpenterie': [
    { name: '2x3x8 SPF', unit: 'un', price: 5 },
    { name: '2x4x8 SPF', unit: 'un', price: 6.50 },
    { name: '2x4x10 SPF', unit: 'un', price: 8.50 },
    { name: '2x4x12 SPF', unit: 'un', price: 10.50 },
    { name: '2x4x16 SPF', unit: 'un', price: 14 },
    { name: '2x6x8 SPF', unit: 'un', price: 9.50 },
    { name: '2x6x10 SPF', unit: 'un', price: 12 },
    { name: '2x6x12 SPF', unit: 'un', price: 15 },
    { name: '2x6x16 SPF', unit: 'un', price: 22 },
    { name: '2x8x10 SPF', unit: 'un', price: 16 },
    { name: '2x8x12 SPF', unit: 'un', price: 19 },
    { name: '2x8x16 SPF', unit: 'un', price: 28 },
    { name: '2x10x10 SPF', unit: 'un', price: 22 },
    { name: '2x10x12 SPF', unit: 'un', price: 28 },
    { name: '2x10x16 SPF', unit: 'un', price: 38 },
    { name: '2x12x12 SPF', unit: 'un', price: 32 },
    { name: '2x12x16 SPF', unit: 'un', price: 45 },
    { name: '4x4x8 traité', unit: 'un', price: 22 },
    { name: '4x6x8 traité', unit: 'un', price: 38 },
    { name: '6x6x8 traité', unit: 'un', price: 52 },
    { name: '1x3x8 SPF', unit: 'un', price: 3.50 },
    { name: '1x4x8 SPF', unit: 'un', price: 4.50 },
    { name: '1x6x8 SPF', unit: 'un', price: 6 },
    { name: 'Contreplaqué 3/8"', unit: 'feuille', price: 32 },
    { name: 'Contreplaqué 1/2"', unit: 'feuille', price: 42 },
    { name: 'Contreplaqué 5/8"', unit: 'feuille', price: 52 },
    { name: 'Contreplaqué 3/4"', unit: 'feuille', price: 68 },
    { name: 'Contreplaqué traité 1/2"', unit: 'feuille', price: 58 },
    { name: 'OSB 7/16"', unit: 'feuille', price: 28 },
    { name: 'OSB 1/2"', unit: 'feuille', price: 32 },
    { name: 'OSB 5/8"', unit: 'feuille', price: 38 },
    { name: 'OSB 3/4" rainuré', unit: 'feuille', price: 52 },
    { name: 'OSB ZIP System', unit: 'feuille', price: 65 },
    { name: 'Poutre LVL 1¾"x9½"', unit: 'pi.lin.', price: 14 },
    { name: 'Poutre LVL 1¾"x11¼"', unit: 'pi.lin.', price: 18 },
    { name: 'Poutre LVL 1¾"x14"', unit: 'pi.lin.', price: 22 },
    { name: 'Poutre Glulam 5⅛"x9"', unit: 'pi.lin.', price: 32 },
    { name: 'Solive ajourée I-joist 9½"', unit: 'pi.lin.', price: 9 },
    { name: 'Solive ajourée I-joist 11⅞"', unit: 'pi.lin.', price: 12 },
    { name: 'Solive ajourée I-joist 14"', unit: 'pi.lin.', price: 16 },
    { name: 'Poutrelle ajourée bois OSB', unit: 'pi.lin.', price: 14 },
    { name: 'Étrier de solive 2x6', unit: 'un', price: 4 },
    { name: 'Étrier de solive 2x8', unit: 'un', price: 5 },
    { name: 'Étrier de solive 2x10', unit: 'un', price: 6.50 },
    { name: 'Sabot de poutre LVL', unit: 'un', price: 18 },
    { name: 'Connecteur d\'angle métallique', unit: 'un', price: 3.50 },
    { name: 'Plaque cloueuse', unit: 'un', price: 2 },
    { name: 'Tirant Simpson H1', unit: 'un', price: 1.80 },
    { name: 'Clous de charpente 3" galv (5 lb)', unit: 'boîte', price: 22 },
    { name: 'Clous de charpente 3½" (5 lb)', unit: 'boîte', price: 24 },
    { name: 'Clous toupie 1¼"', unit: 'boîte', price: 18 },
    { name: 'Vis structurelles 4" (lot 100)', unit: 'boîte', price: 35 },
    { name: 'Vis tirefond 6"', unit: 'boîte', price: 28 },
    { name: 'Boulons de carrosserie 1/2"x6"', unit: 'un', price: 4 },
    { name: 'Tire-fond hex 1/2"x6"', unit: 'un', price: 3.50 },
    { name: 'Membrane pare-vapeur (rouleau)', unit: 'rouleau', price: 32 },
    { name: 'Sangle de charpente continue', unit: 'pi.lin.', price: 1.20 },
  ],
  'Béton et fondation': [
    { name: 'Béton 20 MPa', unit: 'vg.³', price: 265 },
    { name: 'Béton 25 MPa', unit: 'vg.³', price: 285 },
    { name: 'Béton 30 MPa', unit: 'vg.³', price: 305 },
    { name: 'Béton 35 MPa', unit: 'vg.³', price: 325 },
    { name: 'Béton 40 MPa hautes performances', unit: 'vg.³', price: 365 },
    { name: 'Béton à prise rapide', unit: 'vg.³', price: 380 },
    { name: 'Béton autoplaçant', unit: 'vg.³', price: 380 },
    { name: 'Béton fibres synthétiques', unit: 'vg.³', price: 320 },
    { name: 'Mur de fondation coulé 8" (béton + coffrage)', unit: 'pi.lin.', price: 145 },
    { name: 'Mur de fondation coulé 10" (béton + coffrage)', unit: 'pi.lin.', price: 175 },
    { name: 'Mur de fondation ICF 8"', unit: 'pi.lin.', price: 195 },
    { name: 'Semelle de fondation 16"x8" coulée', unit: 'pi.lin.', price: 38 },
    { name: 'Semelle de fondation 20"x10" coulée', unit: 'pi.lin.', price: 52 },
    { name: 'Drain français périphérique (4" perforé)', unit: 'pi.lin.', price: 14 },
    { name: 'Membrane d\'étanchéité fondation appliquée', unit: 'pi.lin.', price: 9 },
    { name: 'Solin métallique de fondation', unit: 'pi.lin.', price: 6.50 },
    { name: 'Solive de plancher 2x10 installée', unit: 'pi.lin.', price: 12 },
    { name: 'Solive de plancher 2x12 installée', unit: 'pi.lin.', price: 14 },
    { name: 'Poutre LVL 1¾"x11⅞" installée', unit: 'pi.lin.', price: 38 },
    { name: 'Lisse basse traitée 2x6', unit: 'pi.lin.', price: 4.50 },
    { name: 'Sac béton prémélangé 30 kg', unit: 'sac', price: 7 },
    { name: 'Sac mortier de maçonnerie 30 kg', unit: 'sac', price: 8 },
    { name: 'Sac ciment Portland 40 kg', unit: 'sac', price: 12 },
    { name: 'Sable de béton', unit: 'tonne', price: 32 },
    { name: 'Pierre 0-3/4" concassée', unit: 'tonne', price: 38 },
    { name: 'Gravier de remblai', unit: 'tonne', price: 28 },
    { name: 'Sable de remblai', unit: 'tonne', price: 32 },
    { name: 'Treillis 6x6 W2.9xW2.9', unit: 'pi.²', price: 0.75 },
    { name: 'Treillis 6x6 W4xW4', unit: 'pi.²', price: 1.20 },
    { name: 'Acier d\'armature 10M (20\')', unit: 'un', price: 12 },
    { name: 'Acier d\'armature 15M (20\')', unit: 'un', price: 22 },
    { name: 'Acier d\'armature 20M (20\')', unit: 'un', price: 38 },
    { name: 'Fil métallique d\'attache', unit: 'rouleau', price: 18 },
    { name: 'Cale plastique pour armature', unit: 'lot', price: 12 },
    { name: 'Coffrage isolé ICF (Logix)', unit: 'pi.²', price: 8.50 },
    { name: 'Coffrage en bois (location)', unit: 'pi.²', price: 3 },
    { name: 'Sonotube 8"', unit: 'pi.lin.', price: 6 },
    { name: 'Sonotube 10"', unit: 'pi.lin.', price: 8 },
    { name: 'Sonotube 12"', unit: 'pi.lin.', price: 10 },
    { name: 'Big Foot pour sonotube', unit: 'un', price: 32 },
    { name: 'Pieu vissé 8\'', unit: 'un', price: 380 },
    { name: 'Membrane d\'étanchéité (rouleau)', unit: 'rouleau', price: 165 },
    { name: 'Membrane drainante Delta-MS', unit: 'rouleau', price: 285 },
    { name: 'Drain agricole 4" perforé', unit: 'pi.lin.', price: 1.85 },
    { name: 'Manchon de drain', unit: 'un', price: 4 },
    { name: 'Té de drain', unit: 'un', price: 8 },
    { name: 'Isolant rigide R-10 fondation', unit: 'feuille', price: 38 },
    { name: 'Isolant rigide XPS R-15', unit: 'feuille', price: 65 },
    { name: 'Ancrage en J pour mur', unit: 'un', price: 1.50 },
    { name: 'Ancrage chimique', unit: 'tube', price: 28 },
    { name: 'Plaque d\'appui', unit: 'un', price: 8 },
    { name: 'Mousse expansive uréthane', unit: 'tube', price: 12 },
    { name: 'Goudron à fondation', unit: 'gallon', price: 38 },
    { name: 'Bloc de béton 8"', unit: 'un', price: 4 },
    { name: 'Brique réfractaire', unit: 'un', price: 8 },
    { name: 'Sciage de béton (location/jour)', unit: 'jour', price: 145 },
    { name: 'Lame diamant 14"', unit: 'un', price: 165 },
  ],
  'Paysagement': [
    { name: 'Tourbe en plaques (rouleau)', unit: 'pi.²', price: 0.85 },
    { name: 'Mélange à gazon 3 kg', unit: 'sac', price: 22 },
    { name: 'Engrais à gazon', unit: 'sac', price: 28 },
    { name: 'Terre noire végétale', unit: 'vg.³', price: 38 },
    { name: 'Compost', unit: 'vg.³', price: 48 },
    { name: 'Terre à jardin', unit: 'sac', price: 6 },
    { name: 'Paillis de cèdre rouge', unit: 'sac', price: 7 },
    { name: 'Paillis de cèdre noir', unit: 'sac', price: 7 },
    { name: 'Paillis de pruche', unit: 'sac', price: 9 },
    { name: 'Paille de couverture', unit: 'balle', price: 12 },
    { name: 'Pavé uni standard', unit: 'pi.²', price: 6.50 },
    { name: 'Pavé uni premium', unit: 'pi.²', price: 9.50 },
    { name: 'Pavé pour stationnement', unit: 'pi.²', price: 8 },
    { name: 'Dalle de patio 24x24', unit: 'un', price: 18 },
    { name: 'Dalle de patio 24x30', unit: 'un', price: 28 },
    { name: 'Dalle de granit', unit: 'pi.²', price: 22 },
    { name: 'Pierre décorative blanche', unit: 'tonne', price: 95 },
    { name: 'Pierre décorative grise', unit: 'tonne', price: 85 },
    { name: 'Galet de rivière', unit: 'tonne', price: 145 },
    { name: 'Géotextile (rouleau)', unit: 'rouleau', price: 95 },
    { name: 'Toile anti-mauvaises herbes', unit: 'rouleau', price: 48 },
    { name: 'Bordure de jardin métal', unit: 'pi.lin.', price: 4.50 },
    { name: 'Bordure de pavé', unit: 'pi.lin.', price: 6 },
    { name: 'Mur de soutènement bloc Pisa', unit: 'pi.²', price: 18 },
    { name: 'Mur de soutènement Allan Block', unit: 'pi.²', price: 22 },
    { name: 'Sable polymère 50 lb', unit: 'sac', price: 32 },
    { name: 'Sable de jointoiement', unit: 'sac', price: 18 },
    { name: 'Arbuste 1 gallon', unit: 'un', price: 18 },
    { name: 'Arbuste 3 gallons', unit: 'un', price: 38 },
    { name: 'Arbuste 5 gallons', unit: 'un', price: 65 },
    { name: 'Conifère 5\'', unit: 'un', price: 145 },
    { name: 'Arbre feuillu 1.5" calibré', unit: 'un', price: 165 },
    { name: 'Arbre feuillu 2.5" calibré', unit: 'un', price: 380 },
    { name: 'Vivace 1 gallon', unit: 'un', price: 12 },
    { name: 'Plante annuelle (caissette)', unit: 'caissette', price: 18 },
    { name: 'Tuteur d\'arbre 8\'', unit: 'un', price: 12 },
    { name: 'Sangle d\'arbre', unit: 'un', price: 4 },
    { name: 'Clôture cèdre 6\' assemblée', unit: 'pi.lin.', price: 38 },
    { name: 'Clôture maillon 4\'', unit: 'pi.lin.', price: 18 },
    { name: 'Clôture aluminium ornemental', unit: 'pi.lin.', price: 65 },
    { name: 'Poteau cèdre 4x4x8', unit: 'un', price: 22 },
    { name: 'Système d\'arrosage (zone)', unit: 'zone', price: 280 },
    { name: 'Tuyau goutte-à-goutte 100\'', unit: 'rouleau', price: 38 },
    { name: 'Bassin de jardin préformé 200 gal', unit: 'un', price: 380 },
    { name: 'Pompe à fontaine', unit: 'un', price: 145 },
    { name: 'Lumière de paysagement DEL', unit: 'un', price: 65 },
  ],
  'Démolition': [
    { name: 'Conteneur 10 vg.³', unit: 'un', price: 320 },
    { name: 'Conteneur 14 vg.³', unit: 'un', price: 380 },
    { name: 'Conteneur 20 vg.³', unit: 'un', price: 480 },
    { name: 'Conteneur 30 vg.³', unit: 'un', price: 620 },
    { name: 'Conteneur 40 vg.³', unit: 'un', price: 780 },
    { name: 'Sacs à débris résistants 33 gal', unit: 'lot', price: 28 },
    { name: 'Sacs gros débris (Tarp Bag)', unit: 'un', price: 65 },
    { name: 'Bâche de protection 10x20', unit: 'un', price: 35 },
    { name: 'Plastique de protection (rouleau)', unit: 'rouleau', price: 48 },
    { name: 'Ruban d\'avertissement rouge', unit: 'rouleau', price: 18 },
    { name: 'Ruban barricade noir-jaune', unit: 'rouleau', price: 12 },
    { name: 'Marteau-piqueur électrique 35 lb', unit: 'jour', price: 95 },
    { name: 'Marteau-piqueur 65 lb', unit: 'jour', price: 145 },
    { name: 'Scie réciproque (location)', unit: 'jour', price: 45 },
    { name: 'Lames de scie réciproque (lot 5)', unit: 'lot', price: 22 },
    { name: 'Disque diamanté 14"', unit: 'un', price: 145 },
    { name: 'Disque à béton 7"', unit: 'un', price: 35 },
    { name: 'Pic à démolition', unit: 'un', price: 38 },
    { name: 'Barre à clous (Wrecking bar)', unit: 'un', price: 32 },
    { name: 'Pelle ronde', unit: 'un', price: 35 },
    { name: 'Brouette 6 pi.³', unit: 'un', price: 145 },
    { name: 'Aspirateur de chantier', unit: 'un', price: 280 },
    { name: 'Masque N95 (boîte 20)', unit: 'boîte', price: 38 },
    { name: 'Masque P100 réutilisable', unit: 'un', price: 48 },
    { name: 'Gants de travail (paire)', unit: 'paire', price: 12 },
    { name: 'Lunettes de sécurité', unit: 'un', price: 8 },
    { name: 'Casque de chantier', unit: 'un', price: 28 },
    { name: 'Bouchons d\'oreilles (lot)', unit: 'lot', price: 12 },
    { name: 'Coquilles antibruit', unit: 'un', price: 28 },
    { name: 'Bottes de sécurité', unit: 'paire', price: 165 },
    { name: 'Trousse de premiers soins', unit: 'un', price: 38 },
    { name: 'Test plomb/amiante (laboratoire)', unit: 'un', price: 145 },
  ],
  'Agrandissement': [
    { name: 'Permis de construction municipal', unit: 'un', price: 850 },
    { name: 'Plan d\'architecte', unit: 'un', price: 2500 },
    { name: 'Plan d\'ingénieur structural', unit: 'un', price: 1850 },
    { name: 'Test de sol (BNQ)', unit: 'un', price: 480 },
    { name: 'Arpentage', unit: 'un', price: 850 },
    { name: 'Excavation pelle mécanique', unit: 'heure', price: 145 },
    { name: 'Camion à bascule', unit: 'heure', price: 95 },
    { name: 'Béton fondation 25 MPa', unit: 'vg.³', price: 295 },
    { name: 'Coffrage de fondation', unit: 'pi.²', price: 8.50 },
    { name: 'Mur de fondation neuf coulé 8"', unit: 'pi.lin.', price: 145 },
    { name: 'Mur de fondation neuf coulé 10"', unit: 'pi.lin.', price: 175 },
    { name: 'Semelle de fondation 16"x8"', unit: 'pi.lin.', price: 38 },
    { name: 'Drain français périphérique', unit: 'pi.lin.', price: 14 },
    { name: 'Mur ossature 2x6 16" C/C (montage)', unit: 'pi.lin.', price: 28 },
    { name: 'Mur ossature 2x8 16" C/C (montage)', unit: 'pi.lin.', price: 36 },
    { name: 'Charpente complète clé en main', unit: 'pi.²', price: 28 },
    { name: 'Solive de plancher 2x10 installée', unit: 'pi.lin.', price: 12 },
    { name: 'Solive de plancher 2x12 installée', unit: 'pi.lin.', price: 14 },
    { name: 'Poutre LVL 1¾"x11⅞" installée', unit: 'pi.lin.', price: 38 },
    { name: 'Toiture complète clé en main', unit: 'pi.²', price: 12 },
    { name: 'Revêtement extérieur clé en main', unit: 'pi.²', price: 9 },
    { name: 'Soffite et fascia aluminium installés', unit: 'pi.lin.', price: 18 },
    { name: 'Gouttière aluminium 5" installée', unit: 'pi.lin.', price: 12 },
    { name: 'Gouttière aluminium 6" installée', unit: 'pi.lin.', price: 16 },
    { name: 'Fenêtre PVC standard', unit: 'un', price: 580 },
    { name: 'Fenêtre PVC haut de gamme', unit: 'un', price: 950 },
    { name: 'Fenêtre hybride alu/PVC', unit: 'un', price: 1250 },
    { name: 'Porte-patio 6\' standard', unit: 'un', price: 1450 },
    { name: 'Porte-patio 8\' premium', unit: 'un', price: 2200 },
    { name: 'Porte d\'entrée acier', unit: 'un', price: 850 },
    { name: 'Porte d\'entrée fibre de verre', unit: 'un', price: 1850 },
    { name: 'Isolation R-24 murs (laine)', unit: 'pi.²', price: 2.20 },
    { name: 'Isolation R-31 plafond', unit: 'pi.²', price: 2.80 },
    { name: 'Isolation cellulose soufflée R-50', unit: 'pi.²', price: 1.80 },
    { name: 'Mousse uréthane giclée 2 lb (R-12)', unit: 'pi.²', price: 4.50 },
    { name: 'Pare-vapeur polyéthylène', unit: 'rouleau', price: 38 },
    { name: 'Pare-air extérieur (Tyvek)', unit: 'rouleau', price: 145 },
    { name: 'Gypse 1/2" régulier', unit: 'feuille', price: 12 },
    { name: 'Gypse 5/8" type X', unit: 'feuille', price: 16 },
    { name: 'Gypse résistant à l\'humidité', unit: 'feuille', price: 18 },
    { name: 'Tirage de joints + finition', unit: 'pi.²', price: 1.80 },
    { name: 'Plinthe et boiserie', unit: 'pi.lin.', price: 4 },
    { name: 'Moulure couronne (crown)', unit: 'pi.lin.', price: 6.50 },
    { name: 'Cadre de porte intérieur', unit: 'un', price: 145 },
    { name: 'Porte intérieure prêt-à-poser', unit: 'un', price: 220 },
    { name: 'Escalier intérieur sur mesure', unit: 'marche', price: 85 },
    { name: 'Main courante bois', unit: 'pi.lin.', price: 22 },
    { name: 'Garde-corps métal', unit: 'pi.lin.', price: 48 },
    { name: 'Garde-corps verre', unit: 'pi.lin.', price: 145 },
  ],
  'Autre': [
    { name: 'Item personnalisé', unit: 'un', price: 0 },
  ],
};

// EN catalog mirrors FR by unit & price; descriptions translated.
const EN_MAP_KEYS = {
  'Rénovation cuisine': 'Kitchen renovation',
  'Rénovation salle de bain': 'Bathroom renovation',
  'Toiture': 'Roofing',
  'Revêtement extérieur': 'Exterior siding',
  'Plancher': 'Flooring',
  'Peinture': 'Painting',
  'Électricité': 'Electrical',
  'Plomberie': 'Plumbing',
  'Charpenterie': 'Framing',
  'Béton et fondation': 'Concrete & foundation',
  'Paysagement': 'Landscaping',
  'Démolition': 'Demolition',
  'Agrandissement': 'Home addition',
  'Autre': 'Other',
};

// Translate item descriptions for EN. Keep same units.
const EN_TRANSLATIONS = {
  'pi.lin.': 'lin.ft', 'pi.²': 'sq.ft', 'pi.³': 'cu.ft',
  'vg.²': 'sq.yd', 'vg.³': 'cu.yd', 'm.²': 'sq.m', 'm.³': 'cu.m',
  'un': 'unit', 'paquet': 'bundle', 'rouleau': 'roll', 'feuille': 'sheet',
  'sac': 'bag', 'tonne': 'ton', 'gallon': 'gallon', 'litre': 'liter',
  'tube': 'tube', 'pot': 'pot', 'seau': 'pail', 'lot': 'set', 'boîte': 'box',
  'heure': 'hour', 'jour': 'day', 'kit': 'kit', 'mètre': 'meter',
  'caissette': 'tray', 'balle': 'bale', 'paire': 'pair', 'zone': 'zone',
  'marche': 'step',
};

// Comprehensive FR → EN dictionary for material names.
// Strategy: lowercase input, replace longest phrases first, then single words,
// then re-capitalize the first letter. This guarantees full English output
// regardless of input casing or position in the string.
// Order matters: multi-word expressions MUST come before their component words.
const EN_PHRASE_MAP = [
  // === Multi-word phrases (must come first) ===
  ['pierre de parement', 'stone veneer'],
  ['brique de parement', 'brick veneer'],
  ['pierre décorative', 'decorative stone'],
  ['mur de soutènement', 'retaining wall'],
  ['mur de fondation', 'foundation wall'],
  ['lave-vaisselle', 'dishwasher'],
  ['micro-ondes', 'microwave'],
  ['bois franc', 'hardwood'],
  ['bois d\'ingénierie', 'engineered wood'],
  ['bois exotique', 'exotic wood'],
  ['quart-de-rond', 'quarter round'],
  ['quart de rond', 'quarter round'],
  ['marteau-piqueur', 'jackhammer'],
  ['marteau démolition', 'demolition hammer'],
  ['ruban à masquer', 'masking tape'],
  ['ruban à joints', 'joint tape'],
  ['ruban électrique', 'electrical tape'],
  ['pâte à joints', 'joint compound'],
  ['composé à joint', 'joint compound'],
  ['composé léger', 'lightweight compound'],
  ['pâte à joint plombier', 'plumbing pipe joint compound'],
  ['pâte à souder', 'soldering paste'],
  ['panneau électrique', 'electrical panel'],
  ['sous-panneau', 'sub-panel'],
  ['câble romex', 'romex cable'],
  ['boîte électrique', 'electrical box'],
  ['boîte étanche', 'weatherproof box'],
  ['plafonnier encastré', 'recessed light'],
  ['luminaire suspendu', 'pendant light'],
  ['luminaire mural', 'wall sconce'],
  ['lumière de chemin', 'pathway light'],
  ['lumière de paysagement', 'landscape light'],
  ['lumière garage', 'garage light'],
  ['valve d\'arrêt', 'shut-off valve'],
  ['valve à bille', 'ball valve'],
  ['valve principale', 'main valve'],
  ['valve anti-retour', 'check valve'],
  ['valve mélangeuse douche', 'shower mixing valve'],
  ['valve mélangeuse', 'mixing valve'],
  ['soupape mélangeuse thermostatique', 'thermostatic mixing valve'],
  ['réducteur de pression', 'pressure reducer'],
  ['adoucisseur d\'eau', 'water softener'],
  ['système osmose inversée', 'reverse osmosis system'],
  ['système caloporteur radiant', 'radiant heat transfer system'],
  ['système de filtration', 'filtration system'],
  ['système d\'irrigation', 'irrigation system'],
  ['système d\'arrosage', 'sprinkler system'],
  ['tête d\'arrosage', 'sprinkler head'],
  ['programmateur d\'irrigation', 'irrigation timer'],
  ['filtre à sédiments', 'sediment filter'],
  ['chauffe-eau', 'water heater'],
  ['plancher chauffant', 'heated floor'],
  ['plinthe chauffante', 'baseboard heater'],
  ['ruban chauffant', 'heating cable'],
  ['acier d\'armature', 'rebar'],
  ['acier galvanisé', 'galvanized steel'],
  ['acier prélaqué', 'pre-painted steel'],
  ['pieu vissé', 'helical pile'],
  ['big foot', 'big foot footing'],
  ['drain français', 'french drain'],
  ['drain agricole', 'agricultural drain'],
  ['drain de plancher', 'floor drain'],
  ['drain linéaire', 'linear drain'],
  ['drain linéaire douche', 'linear shower drain'],
  ['renvoi en p', 'p-trap'],
  ['avaloir de sol', 'floor drain'],
  ['fosse drain français', 'french drain pit'],
  ['bassin de rétention', 'retention basin'],
  ['bassin préformé', 'preformed basin'],
  ['bassin de jardin', 'garden pond'],
  ['pompe à fontaine', 'fountain pump'],
  ['pompe submersible', 'submersible pump'],
  ['pompe à éjecteur', 'ejector pump'],
  ['pompe de puits', 'well pump'],
  ['pompe sump pit', 'sump pit pump'],
  ['pompe à eaux usées', 'sewage pump'],
  ['pompe bassin', 'pond pump'],
  ['réservoir à pression', 'pressure tank'],
  ['réservoir expansion thermique', 'thermal expansion tank'],
  ['col-de-cygne', 'gooseneck'],
  ['col de cygne', 'gooseneck'],
  ['douchette portative à barre verticale', 'handheld showerhead on vertical bar'],
  ['douchette portative', 'portable handheld shower'],
  ['douchette', 'handheld shower'],
  ['à douchette extractible', 'with pull-out spray'],
  ['à douchette', 'with sprayer'],
  ['pomme de douche', 'showerhead'],
  ['barre de douche', 'shower bar'],
  ['robinet de bain', 'bathtub faucet'],
  ['robinet de douche', 'shower faucet'],
  ['robinet de remplissage', 'pot filler'],
  ['robinet à commande tactile', 'touch-control faucet'],
  ['robinet cuisine', 'kitchen faucet'],
  ['robinet vanité', 'vanity faucet'],
  ['robinet extérieur', 'outdoor faucet'],
  ['mitigeur thermostatique', 'thermostatic mixer'],
  ['mitigeur monocommande', 'single-handle mixer'],
  ['mitigeur', 'mixer'],
  ['base de douche', 'shower base'],
  ['porte de douche', 'shower door'],
  ['porte-douche', 'shower door'],
  ['banc de douche', 'shower bench'],
  ['niche encastrée douche', 'recessed shower niche'],
  ['niche encastrée', 'recessed niche'],
  ['bain encastré', 'built-in tub'],
  ['bain podium', 'platform tub'],
  ['bain autoportant', 'freestanding tub'],
  ['bain tourbillon', 'whirlpool tub'],
  ['barre d\'appui', 'grab bar'],
  ['toilette suspendue', 'wall-hung toilet'],
  ['toilette double chasse', 'dual-flush toilet'],
  ['toilette allongée', 'elongated toilet'],
  ['toilette intelligente bidet', 'smart bidet toilet'],
  ['garniture toilette', 'toilet trim kit'],
  ['porte-papier hygiénique', 'toilet paper holder'],
  ['porte-serviettes', 'towel bar'],
  ['sèche-serviettes', 'towel warmer'],
  ['crochet à serviette', 'towel hook'],
  ['porte-savon', 'soap dish'],
  ['distributeur de savon', 'soap dispenser'],
  ['distributeur d\'eau chaude instantanée', 'instant hot water dispenser'],
  ['miroir biseauté', 'beveled mirror'],
  ['miroir avec éclairage del', 'led-lit mirror'],
  ['miroir led rétroéclairé', 'led backlit mirror'],
  ['miroir intelligent défrosting', 'smart defogging mirror'],
  ['pharmacie encastrée', 'recessed medicine cabinet'],
  ['armoire mélamine', 'melamine cabinet'],
  ['armoire mdf thermoplastique', 'thermofoil MDF cabinet'],
  ['armoire bois massif', 'solid wood cabinet'],
  ['armoire sur mesure haut de gamme', 'high-end custom cabinet'],
  ['façade de tiroir', 'drawer front'],
  ['mécanisme tiroir blum', 'blum drawer slide'],
  ['charnière à fermeture lente', 'soft-close hinge'],
  ['poignée armoire', 'cabinet handle'],
  ['bouton armoire', 'cabinet knob'],
  ['comptoir stratifié', 'laminate countertop'],
  ['comptoir quartz', 'quartz countertop'],
  ['comptoir granit', 'granite countertop'],
  ['comptoir bois bloc boucher', 'butcher block countertop'],
  ['comptoir béton sur mesure', 'custom concrete countertop'],
  ['comptoir vanité', 'vanity countertop'],
  ['dosseret céramique', 'ceramic backsplash'],
  ['dosseret verre trempé', 'tempered glass backsplash'],
  ['dosseret inox', 'stainless steel backsplash'],
  ['dosseret marbre', 'marble backsplash'],
  ['crédence carreaux mosaïque', 'mosaic tile backsplash'],
  ['crédence pierre naturelle', 'natural stone backsplash'],
  ['crédence', 'backsplash'],
  ['caisson d\'armoire bas', 'lower cabinet box'],
  ['caisson d\'armoire haut', 'upper cabinet box'],
  ['caisson coulissant épices', 'spice pull-out cabinet'],
  ['plateau tournant coin', 'lazy susan'],
  ['tiroir intérieur sur mesure', 'custom inner drawer'],
  ['tiroir-réchaud', 'warming drawer'],
  ['banc fenêtre encastré', 'window seat bench'],
  ['plinthe chauffante électrique', 'electric baseboard heater'],
  ['évier ferme apron', 'apron-front farmhouse sink'],
  ['évier composite quartz double', 'double quartz composite sink'],
  ['évier inox simple', 'single stainless steel sink'],
  ['évier inox double', 'double stainless steel sink'],
  ['évier sous comptoir', 'undermount sink'],
  ['évier en granit composite', 'granite composite sink'],
  ['cuisinière à induction', 'induction range'],
  ['cuisinière à gaz', 'gas range'],
  ['cuisinière électrique', 'electric range'],
  ['cuisinière double four', 'double oven range'],
  ['réfrigérateur 3 portes french door', 'french door 3-door refrigerator'],
  ['réfrigérateur 2 portes', '2-door refrigerator'],
  ['réfrigérateur encastré', 'built-in refrigerator'],
  ['refroidisseur à vin encastré', 'built-in wine cooler'],
  ['compacteur de déchets', 'trash compactor'],
  ['broyeur alimentaire', 'garbage disposal'],
  ['four mural simple', 'single wall oven'],
  ['four mural double', 'double wall oven'],
  ['lave-vaisselle silencieux haut de gamme', 'high-end silent dishwasher'],
  ['lave-vaisselle encastré', 'built-in dishwasher'],
  ['hotte de cuisinière', 'range hood'],
  ['hotte îlot suspendue', 'island range hood'],
  ['îlot de cuisine', 'kitchen island'],
  ['îlot avec rangement', 'kitchen island with storage'],
  ['tabouret îlot', 'island stool'],
  ['tablette ouverte', 'open shelf'],
  ['garde-manger encastré', 'built-in pantry'],
  ['vanité flottante sur mesure', 'custom floating vanity'],
  ['lavabo encastré porcelaine', 'porcelain drop-in sink'],
  ['lavabo vasque sur comptoir', 'vessel sink countertop'],
  ['lavabo', 'lavatory sink'],
  ['bardeau d\'asphalte', 'asphalt shingle'],
  ['bardeau de cèdre', 'cedar shingle'],
  ['bardeau métallique', 'metal shingle'],
  ['bardeau architectural', 'architectural shingle'],
  ['tôle d\'acier nervurée', 'corrugated steel sheet'],
  ['tôle d\'acier prépeinte', 'pre-painted steel sheet'],
  ['tôle profilée à joint debout', 'standing-seam metal sheet'],
  ['membrane élastomère sablée', 'sanded elastomer membrane'],
  ['membrane élastomère granulée', 'granulated elastomer membrane'],
  ['membrane élastomère', 'elastomer membrane'],
  ['membrane tpo', 'TPO membrane'],
  ['membrane epdm', 'EPDM membrane'],
  ['membrane d\'imperméabilisation', 'waterproofing membrane'],
  ['membrane d\'étanchéité', 'sealing membrane'],
  ['membrane d\'étanchéité fondation appliquée', 'applied foundation waterproofing membrane'],
  ['membrane drainante', 'drainage membrane'],
  ['membrane de découplage', 'uncoupling membrane'],
  ['membrane découplage', 'uncoupling membrane'],
  ['membrane chauffante', 'heating membrane'],
  ['membrane à tapis chauffant', 'underfloor heating mat'],
  ['membrane de solin auto-adhésive', 'self-adhesive flashing membrane'],
  ['membrane delta-ms', 'Delta-MS membrane'],
  ['membrane henry blueskin', 'Henry Blueskin membrane'],
  ['membrane soprema soprastick', 'Soprema Soprastick membrane'],
  ['membrane tyvek homewrap', 'Tyvek HomeWrap membrane'],
  ['pare-vapeur', 'vapor barrier'],
  ['pare-air', 'air barrier'],
  ['pare-neige', 'snow guard'],
  ['sous-couche feutre', 'felt underlayment'],
  ['sous-couche synthétique', 'synthetic underlayment'],
  ['sous-couche autocollante', 'self-adhesive underlayment'],
  ['sous-couche acoustique', 'acoustic underlayment'],
  ['sous-couche', 'underlayment'],
  ['sous-tapis', 'carpet underlay'],
  ['sous-tapis liège', 'cork carpet underlay'],
  ['sous-tapis acoustique', 'acoustic carpet underlay'],
  ['larmier en aluminium', 'aluminum drip edge'],
  ['larmier en acier galvanisé', 'galvanized steel drip edge'],
  ['larmier', 'drip edge'],
  ['solin de cheminée préfab', 'prefab chimney flashing'],
  ['solin de cheminée préformé', 'preformed chimney flashing'],
  ['solin de cheminée', 'chimney flashing'],
  ['solin métallique', 'metal flashing'],
  ['solin métallique de fondation', 'metal foundation flashing'],
  ['solin extrémité', 'end flashing'],
  ['solin au pied', 'base flashing'],
  ['solin de mur', 'wall flashing'],
  ['solin de fenêtre', 'window flashing'],
  ['solin', 'flashing'],
  ['évent de toit', 'roof vent'],
  ['évent de toit maximum', 'maximum-flow roof vent'],
  ['évent de toit max', 'max-flow roof vent'],
  ['évent faîtière', 'ridge vent'],
  ['évent de salle de bain', 'bathroom vent'],
  ['évent de sécheuse', 'dryer vent'],
  ['évent à façade soffite', 'soffit vent'],
  ['évent à façade', 'fascia vent'],
  ['évent de plomberie', 'plumbing vent'],
  ['évent de toiture plomberie', 'plumbing roof vent'],
  ['évent', 'vent'],
  ['cheminée renforcée', 'reinforced chimney'],
  ['coiffe de cheminée inox', 'stainless steel chimney cap'],
  ['cheminée', 'chimney'],
  ['soffite vinyle', 'vinyl soffit'],
  ['soffite vinyle ventilé', 'vented vinyl soffit'],
  ['soffite aluminium', 'aluminum soffit'],
  ['soffite et fascia aluminium installés', 'installed aluminum soffit and fascia'],
  ['soffite', 'soffit'],
  ['fascia aluminium', 'aluminum fascia'],
  ['fascia', 'fascia'],
  ['gouttière aluminium', 'aluminum gutter'],
  ['gouttière', 'gutter'],
  ['descente pluviale', 'downspout'],
  ['descente gouttière aluminium', 'aluminum downspout'],
  ['descente gouttière', 'downspout'],
  ['filet protège-gouttière', 'gutter guard'],
  ['grille protection gouttière', 'gutter protection grille'],
  ['conteneur 14 vg.³ pour vieux bardeaux', '14 cu.yd dumpster for old shingles'],
  ['conteneur', 'dumpster'],
  ['location conteneur', 'dumpster rental'],
  ['bardage vinyle entrée de gamme', 'entry-level vinyl siding'],
  ['bardage vinyle premium', 'premium vinyl siding'],
  ['bardage vinyle haut de gamme', 'high-end vinyl siding'],
  ['bardage vinyle texturé bois', 'wood-textured vinyl siding'],
  ['bardage vinyle', 'vinyl siding'],
  ['bardage en fibrociment', 'fiber cement siding'],
  ['bardage de cèdre', 'cedar siding'],
  ['bardage de cèdre rouge', 'red cedar siding'],
  ['bardage cèdre rouge naturel', 'natural red cedar siding'],
  ['bardage en pin traité', 'treated pine siding'],
  ['bardage pin torréfié', 'torrefied pine siding'],
  ['bardage en aluminium', 'aluminum siding'],
  ['bardage aluminium prélaqué', 'pre-painted aluminum siding'],
  ['bardage en acier', 'steel siding'],
  ['bardage acier prélaqué', 'pre-painted steel siding'],
  ['bardage', 'siding'],
  ['maibec déclin cèdre prépeint', 'Maibec pre-painted cedar bevel siding'],
  ['maibec carrick prépeint', 'Maibec Carrick pre-painted siding'],
  ['canexel déclin', 'Canexel bevel siding'],
  ['hardie plank fibrociment', 'Hardie Plank fiber cement'],
  ['hardie panel fibrociment', 'Hardie Panel fiber cement'],
  ['stucco acrylique', 'acrylic stucco'],
  ['stucco traditionnel', 'traditional stucco'],
  ['acrylique élastomère safi', 'SAFI elastomeric acrylic'],
  ['bois canexel', 'Canexel wood'],
  ['panneau métallique architectural', 'architectural metal panel'],
  ['moulure j-trim vinyle', 'vinyl J-trim molding'],
  ['profilé j vinyle', 'vinyl J-trim profile'],
  ['coin extérieur vinyle', 'outside vinyl corner'],
  ['coin extérieur fibrociment', 'outside fiber cement corner'],
  ['coin moulé extérieur vinyle', 'molded outside vinyl corner'],
  ['lattes de fond', 'furring strips'],
  ['lattis sous bardage cèdre', 'lath under cedar siding'],
  ['lattes de bois pour rainurage', 'wood slats for grooving'],
  ['lattes de toit', 'roof battens'],
  ['tasseaux', 'furring strips'],
  ['boîte à lampe extérieure', 'outdoor lamp box'],
  ['plancher flottant stratifié', 'floating laminate flooring'],
  ['plancher vinyle', 'vinyl flooring'],
  ['plancher vinyle commercial', 'commercial vinyl flooring'],
  ['bois franc chêne', 'oak hardwood'],
  ['bois franc érable', 'maple hardwood'],
  ['bois franc bouleau jaune', 'yellow birch hardwood'],
  ['bois franc cerisier', 'cherry hardwood'],
  ['bois franc noyer noir', 'black walnut hardwood'],
  ['chêne ingénierie', 'engineered oak'],
  ['chêne massif', 'solid oak'],
  ['érable ingénierie', 'engineered maple'],
  ['vinyle lvt à coller', 'glue-down LVT vinyl'],
  ['vinyle lvp click', 'click-lock LVP vinyl'],
  ['vinyle lvp étanche spc', 'waterproof SPC LVP vinyl'],
  ['stratifié', 'laminate'],
  ['bambou stratifié', 'laminated bamboo'],
  ['bambou strand-woven', 'strand-woven bamboo'],
  ['liège naturel', 'natural cork'],
  ['céramique au sol', 'floor ceramic'],
  ['porcelaine grand format au sol', 'large-format porcelain floor tile'],
  ['porcelaine grand format', 'large-format porcelain'],
  ['tuile céramique', 'ceramic tile'],
  ['tuile porcelaine', 'porcelain tile'],
  ['tuile porcelaine grand format', 'large-format porcelain tile'],
  ['carreaux de marbre', 'marble tiles'],
  ['marbre carrara dalle', 'Carrara marble slab'],
  ['granit dalle', 'granite slab'],
  ['ardoise naturelle', 'natural slate'],
  ['mosaïque verre/marbre', 'glass/marble mosaic'],
  ['mosaïque hexagonale', 'hexagonal mosaic'],
  ['mosaïque pierre naturelle', 'natural stone mosaic'],
  ['mosaïque', 'mosaic'],
  ['béton poli scellé', 'polished sealed concrete'],
  ['tapis berbère bouclé', 'looped berber carpet'],
  ['tapis berbère commercial', 'commercial berber carpet'],
  ['tapis frisé', 'frieze carpet'],
  ['tapis commercial', 'commercial carpet'],
  ['tapis', 'carpet'],
  ['membrane de découplage schluter ditra', 'Schluter Ditra uncoupling membrane'],
  ['membrane chauffante schluter', 'Schluter heating membrane'],
  ['thermostat plancher chauffant wi-fi', 'Wi-Fi heated floor thermostat'],
  ['thermostat plancher chauffant', 'heated floor thermostat'],
  ['thermostat thermopompe wi-fi', 'Wi-Fi heat pump thermostat'],
  ['thermostat intelligent', 'smart thermostat'],
  ['thermostat', 'thermostat'],
  ['plinthes peintes blanches', 'white painted baseboards'],
  ['plinthe pin colonial', 'colonial pine baseboard'],
  ['plinthe chêne massif', 'solid oak baseboard'],
  ['plinthe mdf', 'MDF baseboard'],
  ['plinthes mdf', 'MDF baseboards'],
  ['plinthe', 'baseboard'],
  ['plinthes', 'baseboards'],
  ['moulure de transition t-mold', 'T-mold transition strip'],
  ['bande de transition métallique', 'metal transition strip'],
  ['moulure couronne', 'crown molding'],
  ['moulure', 'molding'],
  ['réducteur de hauteur', 'height reducer'],
  ['seuil de porte aluminium', 'aluminum door threshold'],
  ['colle à bois franc', 'hardwood glue'],
  ['colle à vinyle', 'vinyl glue'],
  ['colle pour lvt', 'LVT adhesive'],
  ['colle abs', 'ABS glue'],
  ['colle pvc', 'PVC glue'],
  ['mortier à céramique', 'tile mortar'],
  ['mortier modifié polymère', 'polymer-modified mortar'],
  ['mortier de maçonnerie', 'masonry mortar'],
  ['mortier réfractaire', 'refractory mortar'],
  ['mortier type s', 'type S mortar'],
  ['coulis sablé', 'sanded grout'],
  ['coulis époxy', 'epoxy grout'],
  ['compensateur de niveau', 'self-leveling compound'],
  ['peinture latex intérieur économique', 'economy interior latex paint'],
  ['peinture latex intérieur standard', 'standard interior latex paint'],
  ['peinture latex intérieur premium', 'premium interior latex paint'],
  ['peinture latex lavable cuisine/sdb', 'washable kitchen/bath latex paint'],
  ['peinture latex extérieur', 'exterior latex paint'],
  ['peinture extérieur 100% acrylique', '100% acrylic exterior paint'],
  ['peinture extérieure latex', 'exterior latex paint'],
  ['peinture mate antitaches', 'matte stain-resistant paint'],
  ['peinture coquille d\'œuf', 'eggshell paint'],
  ['peinture satinée', 'satin paint'],
  ['peinture semi-lustrée', 'semi-gloss paint'],
  ['peinture haute brillance', 'high-gloss paint'],
  ['peinture pour métal', 'metal paint'],
  ['peinture à plancher époxy', 'epoxy floor paint'],
  ['peinture à clôture', 'fence paint'],
  ['peinture pour radiateur', 'radiator paint'],
  ['peinture portes et boiseries semi-lustré', 'semi-gloss door and trim paint'],
  ['peinture plafond mat', 'matte ceiling paint'],
  ['apprêt scellant universel', 'universal sealer primer'],
  ['apprêt scellant fixateur', 'fixing sealer primer'],
  ['apprêt à base d\'huile', 'oil-based primer'],
  ['apprêt anti-tâches', 'stain-blocking primer'],
  ['apprêt bloquant tache shellac', 'shellac stain-blocking primer'],
  ['vernis polyuréthane huile', 'oil-based polyurethane varnish'],
  ['vernis polyuréthane à eau', 'water-based polyurethane varnish'],
  ['teinture intérieur', 'interior stain'],
  ['teinture extérieure semi-transparente', 'semi-transparent exterior stain'],
  ['teinture extérieure opaque', 'opaque exterior stain'],
  ['teinture cèdre semi-transparente', 'semi-transparent cedar stain'],
  ['teinture solide extérieure', 'solid exterior stain'],
  ['teinture transparente', 'transparent stain'],
  ['pinceau angulaire', 'angled brush'],
  ['pinceau plat', 'flat brush'],
  ['pinceau premium wooster', 'premium Wooster brush'],
  ['pinceau wooster', 'Wooster brush'],
  ['pinceau purdy', 'Purdy brush'],
  ['manchon rouleau', 'roller cover'],
  ['manchon rouleau wagner microfibre', 'Wagner microfiber roller cover'],
  ['manchon rouleau mohair', 'mohair roller cover'],
  ['cadre rouleau', 'roller frame'],
  ['plateau peinture standard', 'standard paint tray'],
  ['plateau peinture pro avec doublure', 'pro paint tray with liner'],
  ['plateau peinture jetable', 'disposable paint tray'],
  ['grille de bac rouleau', 'roller bucket grid'],
  ['ruban à masquer frogtape', 'FrogTape masking tape'],
  ['ruban à masquer 3m scotch blue', '3M Scotch Blue masking tape'],
  ['ruban à joints papier', 'paper joint tape'],
  ['ruban à joints fibre de verre', 'fiberglass joint tape'],
  ['ruban tuck tape rouge', 'red Tuck Tape'],
  ['ruban pare-vapeur tuck tape', 'Tuck Tape vapor barrier tape'],
  ['ruban d\'avertissement rouge', 'red warning tape'],
  ['ruban barricade noir-jaune', 'black-yellow barricade tape'],
  ['bâche plastique', 'plastic tarp'],
  ['bâche tissu', 'fabric drop cloth'],
  ['bâche de plastique', 'plastic tarp'],
  ['bâche de protection', 'protective tarp'],
  ['plastique de protection', 'protective plastic'],
  ['toile de protection plancher tissée', 'woven floor protection drop cloth'],
  ['pâte à joints prémélangée', 'premixed joint compound'],
  ['pâte à joints en poudre', 'powder joint compound'],
  ['composé à joint pré-mélangé', 'premixed joint compound'],
  ['composé léger', 'lightweight compound'],
  ['coin métallique pour gypse', 'metal drywall corner bead'],
  ['calfeutrant acrylique blanc', 'white acrylic caulk'],
  ['calfeutrant siliconé', 'silicone caulk'],
  ['calfeutrant à siliconé extérieur', 'exterior silicone caulk'],
  ['calfeutrant peinturable latex', 'paintable latex caulk'],
  ['calfeutrant', 'caulk'],
  ['bouche-pores à bois', 'wood pore filler'],
  ['papier sablé', 'sandpaper'],
  ['bloc à sablage', 'sanding block'],
  ['bloc à sabler éponge', 'sponge sanding block'],
  ['décapant chimique', 'chemical paint stripper'],
  ['diluant à peinture', 'paint thinner'],
  ['spatule masticage', 'putty knife'],
  ['disjoncteur gfci', 'GFCI breaker'],
  ['disjoncteur afci', 'AFCI breaker'],
  ['disjoncteur combo afci/gfci', 'combo AFCI/GFCI breaker'],
  ['disjoncteur afci/gfci duplex', 'duplex AFCI/GFCI breaker'],
  ['disjoncteur 2 pôles', 'double-pole breaker'],
  ['disjoncteur double pôle', 'double-pole breaker'],
  ['disjoncteur simple', 'single-pole breaker'],
  ['disjoncteur dédié', 'dedicated breaker'],
  ['disjoncteur', 'breaker'],
  ['prise standard', 'standard outlet'],
  ['prise gfci', 'GFCI outlet'],
  ['prise usb intégrée', 'integrated USB outlet'],
  ['prise sécheuse', 'dryer outlet'],
  ['prise cuisinière', 'range outlet'],
  ['prise extérieure étanche', 'weatherproof outdoor outlet'],
  ['pieuvre prise sol garage', 'garage floor outlet box'],
  ['prise', 'outlet'],
  ['interrupteur simple', 'single switch'],
  ['interrupteur 3 voies', '3-way switch'],
  ['interrupteur 4 voies', '4-way switch'],
  ['interrupteur intelligent', 'smart switch'],
  ['interrupteur', 'switch'],
  ['gradateur del compatible', 'LED-compatible dimmer'],
  ['gradateur', 'dimmer'],
  ['détecteur de mouvement', 'motion detector'],
  ['détecteur de fumée câblé', 'hardwired smoke detector'],
  ['détecteur co câblé', 'hardwired CO detector'],
  ['détecteur fumée + co combiné', 'combined smoke/CO detector'],
  ['détecteur', 'detector'],
  ['plaque interrupteur simple', 'single switch plate'],
  ['plaque interrupteur double', 'double switch plate'],
  ['plaque inox brossé', 'brushed stainless steel plate'],
  ['plaque cloueuse', 'nail-on plate'],
  ['plaque de béton', 'concrete board'],
  ['plaque d\'appui', 'support plate'],
  ['plaque de jonction', 'connector plate'],
  ['plafonnier encastré del', 'recessed LED light'],
  ['plafonnier sur rail', 'track light'],
  ['plafonnier del salle de bain', 'LED bathroom ceiling light'],
  ['plafonnier rond', 'round ceiling fixture'],
  ['plafonnier', 'ceiling light'],
  ['luminaire vanité', 'vanity light'],
  ['luminaire suspendu îlot', 'island pendant light'],
  ['luminaire suspendu', 'pendant light'],
  ['luminaire mural extérieur', 'outdoor wall sconce'],
  ['luminaire', 'light fixture'],
  ['lumière de paysagement del', 'landscape LED light'],
  ['lumière de chemin', 'pathway light'],
  ['lumière garage del', 'garage LED light'],
  ['lumière garage del haute baie', 'high-bay garage LED light'],
  ['lumière', 'light'],
  ['conduit ent', 'ENT conduit'],
  ['conduit rnmc', 'RNMC conduit'],
  ['conduit flexible isolé', 'insulated flexible duct'],
  ['couvercle conduit extérieur', 'exterior conduit cover'],
  ['connecteur marrette', 'Marrette wire nut'],
  ['borne wago', 'Wago lever nut'],
  ['borne de recharge ve', 'EV charging station'],
  ['borne d\'arrosage souterraine', 'underground hose bib'],
  ['borne d\'arrosage', 'hose bib'],
  ['ruban électrique', 'electrical tape'],
  ['tire-fil', 'fish tape'],
  ['génératrice de secours', 'standby generator'],
  ['génératrice portable', 'portable generator'],
  ['transfer switch automatique', 'automatic transfer switch'],
  ['câble teck90', 'TECK90 cable'],
  ['câble extérieur nmwu', 'outdoor NMWU cable'],
  ['câble ve installation', 'EV installation cable'],
  ['câble', 'cable'],
  ['bande led', 'LED strip'],
  ['driver led', 'LED driver'],
  ['caméra de sécurité ip extérieure', 'outdoor IP security camera'],
  ['caméra thermographie inspection', 'inspection thermal camera'],
  ['caméra de sécurité', 'security camera'],
  ['bouton commande lutron caseta', 'Lutron Caseta control button'],
  ['bouton-poussoir purge bain', 'bathtub drain push-button'],
  ['hub d\'automatisation', 'automation hub'],
  ['sirène intérieure intelligente', 'smart indoor siren'],
  ['serrure intelligente wi-fi', 'Wi-Fi smart lock'],
  ['robinet à commande tactile', 'touch-control faucet'],
  ['conduite frigorifique', 'refrigerant line'],
  ['console linéaire évaporateur', 'linear evaporator console'],
  ['support mural unité extérieure', 'outdoor unit wall bracket'],
  ['plate-forme béton unité extérieure', 'outdoor unit concrete pad'],
  ['thermopompe murale', 'wall-mounted heat pump'],
  ['thermopompe centrale', 'central heat pump'],
  ['climatiseur fenêtre', 'window air conditioner'],
  ['climatiseur portable', 'portable air conditioner'],
  ['échangeur d\'air', 'air exchanger'],
  ['échangeur d\'air vrc venmar', 'Venmar HRV air exchanger'],
  ['échangeur d\'air hve haute efficacité', 'high-efficiency HRV air exchanger'],
  ['grille ventilation', 'ventilation grille'],
  ['diffuseur plafonnier rond', 'round ceiling diffuser'],
  ['filtre hepa fournaise', 'HEPA furnace filter'],
  ['service entretien climatisation', 'AC maintenance service'],
  ['subvention énergir/hydro-québec', 'Énergir/Hydro-Québec rebate'],
  ['tuyau pex', 'PEX pipe'],
  ['tuyau cuivre type m', 'type M copper pipe'],
  ['tuyau cuivre type l', 'type L copper pipe'],
  ['tuyau cuivre', 'copper pipe'],
  ['tuyau abs', 'ABS pipe'],
  ['tuyau pvc', 'PVC pipe'],
  ['tuyau de drainage français', 'french drain pipe'],
  ['tuyau goutte-à-goutte', 'drip irrigation tubing'],
  ['tuyau', 'pipe'],
  ['coude cuivre', 'copper elbow'],
  ['coude pex sans plomb', 'lead-free PEX elbow'],
  ['coude pex', 'PEX elbow'],
  ['coude abs', 'ABS elbow'],
  ['coude transition pex-cuivre', 'PEX-to-copper transition elbow'],
  ['coude', 'elbow'],
  ['té cuivre', 'copper tee'],
  ['té pex', 'PEX tee'],
  ['té abs', 'ABS tee'],
  ['té de drain', 'drain tee'],
  ['réducteur cuivre', 'copper reducer'],
  ['bouchon cuivre', 'copper cap'],
  ['manchon abs', 'ABS coupling'],
  ['manchon de drain', 'drain coupling'],
  ['raccord union pex', 'PEX union fitting'],
  ['sertisseuse pex propress', 'ProPress PEX crimper'],
  ['soudure à l\'argent', 'silver solder'],
  ['téflon ruban', 'Teflon tape'],
  ['apprêt pvc violet', 'purple PVC primer'],
  ['joint torique', 'O-ring'],
  ['chauffe-eau électrique', 'electric water heater'],
  ['chauffe-eau au gaz', 'gas water heater'],
  ['chauffe-eau instantané au gaz', 'tankless gas water heater'],
  ['chauffe-eau instantané électrique', 'tankless electric water heater'],
  ['chauffe-eau pompe à chaleur', 'heat-pump water heater'],
  ['boiler propane combiné chauffage', 'propane combo boiler'],
  ['traité', 'treated'],
  ['contreplaqué traité', 'treated plywood'],
  ['contreplaqué cdx', 'CDX plywood'],
  ['contreplaqué bouleau', 'birch plywood'],
  ['contreplaqué pour toiture', 'roofing plywood'],
  ['contreplaqué', 'plywood'],
  ['osb rainuré', 'tongue-and-groove OSB'],
  ['osb zip system', 'ZIP System OSB'],
  ['osb toiture', 'roofing OSB'],
  ['poutre lvl', 'LVL beam'],
  ['poutre glulam', 'Glulam beam'],
  ['poutre 3 plis', '3-ply built-up beam'],
  ['poutre', 'beam'],
  ['solive ajourée i-joist', 'I-joist'],
  ['poutrelle ajourée bois osb', 'OSB engineered joist'],
  ['solive de plancher', 'floor joist'],
  ['solive', 'joist'],
  ['étrier de solive', 'joist hanger'],
  ['étrier double', 'double hanger'],
  ['étrier solive ouragan simpson', 'Simpson hurricane joist tie'],
  ['étrier', 'hanger'],
  ['sabot de poutre lvl', 'LVL beam hanger'],
  ['connecteur d\'angle métallique', 'metal angle connector'],
  ['tirant simpson h1', 'Simpson H1 hurricane tie'],
  ['pieu d\'ancrage simpson masa', 'Simpson MASA mudsill anchor'],
  ['clous de toiture galv', 'galvanized roofing nails'],
  ['clous de charpente', 'framing nails'],
  ['clous toupie', 'cap nails'],
  ['clous galvanisés revêtement', 'galvanized siding nails'],
  ['clous ordinaires', 'common nails'],
  ['clous gun framing', 'framing gun nails'],
  ['clous', 'nails'],
  ['vis à toiture métallique', 'metal roofing screws'],
  ['vis structurelles', 'structural screws'],
  ['vis structurales grk rss', 'GRK RSS structural screws'],
  ['vis tirefond', 'lag screws'],
  ['vis à gypse', 'drywall screws'],
  ['vis à plancher', 'flooring screws'],
  ['vis camo', 'Camo deck screws'],
  ['vis', 'screws'],
  ['boulons de carrosserie', 'carriage bolts'],
  ['tire-fond hex', 'hex lag bolts'],
  ['sangle de charpente continue', 'continuous framing strap'],
  ['pare-vapeur polyéthylène', 'polyethylene vapor barrier'],
  ['membrane pare-vapeur', 'vapor barrier membrane'],
  ['scellant de toiture', 'roofing sealant'],
  ['scellant acoustique tremco', 'Tremco acoustic sealant'],
  ['scellant pénétrant béton', 'penetrating concrete sealer'],
  ['mastic d\'étanchéité élastomère', 'elastomeric sealing mastic'],
  ['couvre-joint élastomère', 'elastomeric joint cover'],
  ['goudron à toiture', 'roofing tar'],
  ['goudron à fondation', 'foundation tar'],
  ['imperméabilisant goudron fondation', 'tar foundation waterproofer'],
  ['mousse expansive uréthane', 'expanding urethane foam'],
  ['mousse uréthane giclée', 'spray foam urethane'],
  ['mousse hilti expansion joints', 'Hilti expansion joint foam'],
  ['uréthane giclé closed-cell', 'closed-cell spray urethane'],
  ['adhésif construction pl premium', 'PL Premium construction adhesive'],
  ['adhésif construction', 'construction adhesive'],
  ['coupe-feu polyuréthane', 'polyurethane firestop'],
  ['coupe-feu blocs', 'block firestop'],
  ['coupe-feu', 'firestop'],
  ['coupe-froid porte garage', 'garage door weather strip'],
  ['coupe-béton diamantée', 'diamond concrete saw'],
  ['béton 20 mpa', '20 MPa concrete'],
  ['béton 25 mpa', '25 MPa concrete'],
  ['béton 30 mpa', '30 MPa concrete'],
  ['béton 35 mpa', '35 MPa concrete'],
  ['béton 40 mpa hautes performances', 'high-performance 40 MPa concrete'],
  ['béton à prise rapide', 'fast-setting concrete'],
  ['béton autoplaçant', 'self-consolidating concrete'],
  ['béton fibres synthétiques', 'fiber-reinforced concrete'],
  ['béton fondation', 'foundation concrete'],
  ['béton livré', 'delivered concrete'],
  ['pompage béton', 'concrete pumping'],
  ['sac béton prémélangé', 'pre-mixed concrete bag'],
  ['sac mortier de maçonnerie', 'masonry mortar bag'],
  ['sac mortier type s', 'type S mortar bag'],
  ['sac ciment portland', 'Portland cement bag'],
  ['sac béton', 'concrete bag'],
  ['sac de ciment portland', 'Portland cement bag'],
  ['sac de mortier réfractaire', 'refractory mortar bag'],
  ['sable de béton', 'concrete sand'],
  ['sable de remblai', 'fill sand'],
  ['sable polymère', 'polymeric sand'],
  ['sable de jointoiement', 'jointing sand'],
  ['sable maçon', 'mason sand'],
  ['pierre 0-3/4" concassée', 'crushed 0-3/4" stone'],
  ['pierre concassée', 'crushed stone'],
  ['gravier de remblai', 'fill gravel'],
  ['pierre marbre concassée blanche', 'crushed white marble'],
  ['pierre décorative blanche', 'decorative white stone'],
  ['pierre décorative grise', 'decorative gray stone'],
  ['pierre décorative', 'decorative stone'],
  ['galet de rivière', 'river pebble'],
  ['treillis 6x6', '6x6 wire mesh'],
  ['treillis soudé', 'welded wire mesh'],
  ['treillis', 'mesh'],
  ['fil métallique d\'attache', 'tie wire'],
  ['cale plastique pour armature', 'rebar plastic chair'],
  ['coffrage isolé icf', 'ICF insulated formwork'],
  ['coffrage quad-deck', 'Quad-Deck formwork'],
  ['coffrage en bois', 'wood formwork'],
  ['coffrage de fondation', 'foundation formwork'],
  ['coffrage', 'formwork'],
  ['sonotube', 'sonotube'],
  ['drain agricole', 'agricultural drain'],
  ['isolant rigide r-5', 'R-5 rigid insulation'],
  ['isolant rigide r-10', 'R-10 rigid insulation'],
  ['isolant rigide r-15', 'R-15 rigid insulation'],
  ['isolant rigide xps', 'XPS rigid insulation'],
  ['isolant rigide', 'rigid insulation'],
  ['isolant graphite', 'graphite insulation'],
  ['isolation laine de roche', 'rockwool insulation'],
  ['isolation laine de verre', 'fiberglass insulation'],
  ['isolation cellulose soufflée', 'blown cellulose insulation'],
  ['isolation', 'insulation'],
  ['laine de roche rockwool', 'Rockwool stone wool'],
  ['laine de roche comfortbatt', 'Comfortbatt rockwool'],
  ['laine de roche', 'rockwool'],
  ['laine de verre sonopan acoustique', 'Sonopan acoustic fiberglass'],
  ['laine de verre', 'fiberglass'],
  ['cellulose soufflée grenier', 'attic blown cellulose'],
  ['polystyrène extrudé', 'extruded polystyrene'],
  ['polystyrène', 'polystyrene'],
  ['polyisocyanurate', 'polyisocyanurate'],
  ['ancrage en j pour mur', 'J-anchor for wall'],
  ['ancrage chimique', 'chemical anchor'],
  ['brique réfractaire', 'firebrick'],
  ['sciage de béton', 'concrete sawing'],
  ['lame diamant', 'diamond blade'],
  ['lame scie béton diamantée', 'diamond concrete saw blade'],
  ['lame sawzall démolition', 'Sawzall demolition blade'],
  ['disque diamanté', 'diamond disc'],
  ['disque à béton', 'concrete disc'],
  ['scie béton circulaire', 'circular concrete saw'],
  ['scie réciproque', 'reciprocating saw'],
  ['lames de scie réciproque', 'reciprocating saw blades'],
  ['pic à démolition', 'demolition pickaxe'],
  ['barre à clous', 'pry bar'],
  ['pelle ronde', 'round shovel'],
  ['pelle mécanique', 'excavator'],
  ['brouette', 'wheelbarrow'],
  ['aspirateur de chantier', 'shop vacuum'],
  ['aspirateur central garage', 'central garage vacuum'],
  ['masque n95', 'N95 mask'],
  ['masque p100 réutilisable', 'reusable P100 mask'],
  ['masque p100 demi-faciale', 'P100 half-face mask'],
  ['cartouche p100', 'P100 cartridge'],
  ['gants de travail', 'work gloves'],
  ['gants kevlar coupe-résistant', 'cut-resistant Kevlar gloves'],
  ['lunettes de sécurité', 'safety glasses'],
  ['lunettes ansi z87+', 'ANSI Z87+ safety glasses'],
  ['casque de chantier csa', 'CSA hard hat'],
  ['casque de chantier', 'hard hat'],
  ['bouchons d\'oreilles', 'earplugs'],
  ['coquilles antibruit', 'noise-cancelling earmuffs'],
  ['bottes de sécurité', 'safety boots'],
  ['bottes acier csa', 'CSA steel-toe boots'],
  ['trousse de premiers soins', 'first aid kit'],
  ['trousse de plomberie complète douche', 'complete shower plumbing kit'],
  ['test plomb/amiante', 'lead/asbestos test'],
  ['test percolation terrain', 'percolation test'],
  ['test infiltrométrie blower door', 'blower door air leakage test'],
  ['test de sol', 'soil test'],
  ['étude de sol/géotechnique', 'geotechnical soil study'],
  ['permis de construction municipal', 'municipal building permit'],
  ['permis construction municipal', 'municipal building permit'],
  ['permis de démolition municipal', 'municipal demolition permit'],
  ['permis d\'occupation domaine public', 'public domain occupancy permit'],
  ['plan d\'architecte', 'architectural plan'],
  ['plans d\'architecte', 'architectural plans'],
  ['plan d\'ingénieur structural', 'structural engineering plan'],
  ['ingénieur structure', 'structural engineer'],
  ['arpentage', 'land survey'],
  ['camion à bascule', 'dump truck'],
  ['mur ossature 2x6 16" c/c', 'framed 2x6 wall 16" o.c.'],
  ['mur ossature 2x8 16" c/c', 'framed 2x8 wall 16" o.c.'],
  ['charpente complète clé en main', 'turn-key complete framing'],
  ['toiture complète clé en main', 'turn-key complete roof'],
  ['revêtement extérieur clé en main', 'turn-key exterior cladding'],
  ['lisse basse traitée', 'treated bottom plate'],
  ['gypse régulier', 'regular drywall'],
  ['gypse 5/8" type x', '5/8" Type X drywall'],
  ['gypse type x', 'Type X drywall'],
  ['gypse résistant à l\'humidité', 'moisture-resistant drywall'],
  ['gypse résistant à l\'eau', 'water-resistant drywall'],
  ['gypse insonorisant quietrock', 'QuietRock soundproof drywall'],
  ['gypse', 'drywall'],
  ['tirage de joints + finition', 'taping and finishing'],
  ['plinthe et boiserie', 'baseboard and trim'],
  ['cadre de porte intérieur', 'interior door frame'],
  ['cadre de porte intérieure mdf', 'MDF interior door frame'],
  ['porte intérieure prêt-à-poser', 'pre-hung interior door'],
  ['porte intérieure 6 panneaux', '6-panel interior door'],
  ['porte intérieure prémontée bloc', 'pre-assembled interior door block'],
  ['escalier intérieur sur mesure', 'custom interior staircase'],
  ['escalier composite préfabriqué', 'prefab composite stairs'],
  ['escalier', 'stairs'],
  ['main courante bois', 'wood handrail'],
  ['garde-corps métal', 'metal guardrail'],
  ['garde-corps verre', 'glass guardrail'],
  ['garde-corps aluminium pré-fab', 'prefab aluminum guardrail'],
  ['garde-corps câble inox kit', 'stainless steel cable guardrail kit'],
  ['garde-corps', 'guardrail'],
  ['fenêtre pvc standard', 'standard PVC window'],
  ['fenêtre pvc haut de gamme', 'high-end PVC window'],
  ['fenêtre hybride alu/pvc', 'hybrid alu/PVC window'],
  ['fenêtre energy star battant', 'Energy Star casement window'],
  ['fenêtre triple vitrage', 'triple-pane window'],
  ['fenêtre', 'window'],
  ['porte-patio', 'patio door'],
  ['porte-fenêtre coulissante', 'sliding patio door'],
  ['porte patio française', 'French patio door'],
  ['porte d\'entrée acier', 'steel entry door'],
  ['porte d\'entrée fibre de verre', 'fiberglass entry door'],
  ['porte entrée acier isolée', 'insulated steel entry door'],
  ['porte entrée fibre de verre', 'fiberglass entry door'],
  ['poignée porte d\'entrée multipoint', 'multi-point entry door handle'],
  ['quincaillerie poignée passage', 'passage door hardware'],
  ['quincaillerie poignée verrou', 'privacy lock door hardware'],
  ['porte de garage isolée', 'insulated garage door'],
  ['porte de garage double isolée', 'insulated double garage door'],
  ['porte de garage', 'garage door'],
  ['ouvre-porte garage', 'garage door opener'],
  ['ouvre-porte garage wi-fi myq', 'MyQ Wi-Fi garage door opener'],
  ['porte', 'door'],
  ['tourbe en plaques', 'sod rolls'],
  ['tourbe naturelle', 'natural sod'],
  ['mélange à gazon', 'grass seed mix'],
  ['engrais à gazon', 'lawn fertilizer'],
  ['terre noire végétale', 'topsoil'],
  ['terre noire', 'topsoil'],
  ['terre à gazon', 'lawn soil'],
  ['terre à jardin', 'garden soil'],
  ['compost de feuilles', 'leaf compost'],
  ['paille de couverture', 'cover straw'],
  ['paillis de cèdre rouge', 'red cedar mulch'],
  ['paillis de cèdre noir', 'black cedar mulch'],
  ['paillis de pruche', 'hemlock mulch'],
  ['paillis cèdre rouge', 'red cedar mulch'],
  ['paillis noir teint', 'black-dyed mulch'],
  ['paillis', 'mulch'],
  ['pavé uni standard', 'standard interlocking paver'],
  ['pavé uni premium', 'premium interlocking paver'],
  ['pavé uni techo-bloc hera', 'Techo-Bloc Hera interlocking paver'],
  ['pavé uni permacon lafitt', 'Permacon Lafitt interlocking paver'],
  ['pavé uni perméable', 'permeable interlocking paver'],
  ['pavé uni', 'interlocking paver'],
  ['pavé pour stationnement', 'driveway paver'],
  ['pavé chauffant patio chaufferette', 'heated patio paver'],
  ['pavé', 'paver'],
  ['dalle de patio', 'patio slab'],
  ['dalle de granit', 'granite slab'],
  ['dalle', 'slab'],
  ['toile anti-mauvaises herbes', 'weed barrier fabric'],
  ['géotextile nw8', 'NW8 geotextile'],
  ['géogrille renfort mur', 'wall reinforcement geogrid'],
  ['géotextile', 'geotextile'],
  ['bordure de jardin métal', 'metal garden edging'],
  ['bordure de jardin acier corten', 'corten steel garden edging'],
  ['bordure de pavé', 'paver edging'],
  ['bordure pavé', 'paver edging'],
  ['bordure', 'edging'],
  ['mur de soutènement bloc pisa', 'Pisa block retaining wall'],
  ['mur de soutènement allan block', 'Allan Block retaining wall'],
  ['mur de soutènement techo-bloc bristol', 'Techo-Bloc Bristol retaining wall'],
  ['arbuste', 'shrub'],
  ['conifère', 'conifer'],
  ['arbre feuillu', 'deciduous tree'],
  ['arbre', 'tree'],
  ['vivace assortie', 'assorted perennial'],
  ['vivace', 'perennial'],
  ['plante annuelle', 'annual plant'],
  ['tuteur d\'arbre', 'tree stake'],
  ['sangle d\'arbre', 'tree strap'],
  ['cèdre haie blanc', 'white cedar hedge'],
  ['cèdre haie', 'cedar hedge'],
  ['érable rouge', 'red maple'],
  ['lilas commun', 'common lilac'],
  ['hortensia', 'hydrangea'],
  ['clôture cèdre', 'cedar fence'],
  ['clôture maillon', 'chain-link fence'],
  ['clôture maille de chaîne', 'chain-link fence'],
  ['clôture aluminium ornemental', 'ornamental aluminum fence'],
  ['clôture', 'fence'],
  ['poteau cèdre', 'cedar post'],
  ['poteau de clôture', 'fence post'],
  ['pergola cèdre', 'cedar pergola'],
  ['pergola', 'pergola'],
  ['sacs à débris résistants', 'heavy-duty debris bags'],
  ['sac démolition', 'demolition bag'],
  ['sacs gros débris', 'large debris bags'],
  ['sac sable consigne', 'sand bag deposit'],
  ['protection plancher cartonné', 'cardboard floor protection'],
  ['rangement mural pegboard', 'pegboard wall storage'],
  ['rangement plafond rétractable', 'retractable ceiling storage'],
  ['cabinet d\'atelier acier', 'steel workshop cabinet'],
  ['établi commercial', 'commercial workbench'],
  ['compresseur', 'air compressor'],
  ['chauffage suspendu gaz', 'suspended gas heater'],
  ['chauffage électrique infrarouge', 'electric infrared heater'],
  ['tablette acier garage', 'steel garage shelf'],
  ['plancher époxy garage kit', 'garage epoxy floor kit'],
  ['plancher époxy paillette pro', 'pro flake epoxy floor'],
  ['composite trex enhance', 'Trex Enhance composite'],
  ['composite timbertech azek', 'TimberTech AZEK composite'],
  ['cèdre rouge clear', 'clear red cedar'],
  ['pin traité', 'treated pine'],
  ['ipe (bois exotique)', 'Ipe (exotic wood)'],
  ['pieu vissé terrasse', 'deck helical pile'],
  ['toiture toile rétractable', 'retractable canopy roof'],
  ['toiture motorisée pergola', 'motorized pergola roof'],
  ['auvent rétractable', 'retractable awning'],
  ['spa 6 places acrylique installation', '6-person acrylic spa with installation'],
  ['foyer gaz extérieur table', 'outdoor gas fire table'],
  ['cuisine extérieure module', 'outdoor kitchen module'],
  ['éclairage del patio', 'LED patio lighting'],
  ['éclairage sous armoire del', 'under-cabinet LED lighting'],
  ['éclairage', 'lighting'],
  ['clips invisibles composite', 'invisible composite clips'],
  ['cèdre rouge', 'red cedar'],
  ['bois traité', 'treated wood'],
  ['mini-pelle', 'mini excavator'],
  ['bulldozer compact', 'compact bulldozer'],
  ['compacteur plaque', 'plate compactor'],
  ['niveleuse laser', 'laser grader'],
  ['transport remblai', 'fill transport'],
  ['disposition terre/roche', 'soil/rock disposal'],
  ['localisation services publics info-excavation', 'Info-Excavation utility locate'],
  ['programme rénoclimat', 'Rénoclimat program'],
  ['ventilateur extraction grenier solaire', 'solar attic exhaust fan'],
  ['ventilateur de salle de bain', 'bathroom fan'],
  ['ventilateur silencieux', 'silent fan'],
  ['ventilateur avec lumière + bluetooth', 'fan with light + Bluetooth'],
  ['ventilateur', 'fan'],

  // === Single words / smaller terms ===
  ['armoire', 'cabinet'], ['caisson', 'cabinet box'], ['comptoir', 'countertop'],
  ['évier', 'sink'], ['robinet', 'faucet'], ['hotte', 'range hood'],
  ['cuisinière', 'range'], ['réfrigérateur', 'refrigerator'],
  ['vanité', 'vanity'], ['lavabo', 'lavatory'],
  ['toilette', 'toilet'], ['bain', 'bathtub'], ['douche', 'shower'],
  ['miroir', 'mirror'], ['bardeau', 'shingle'], ['membrane', 'membrane'],
  ['cheminée', 'chimney'], ['gouttière', 'gutter'], ['descente', 'downspout'],
  ['plancher', 'floor'], ['plafond', 'ceiling'], ['mur', 'wall'],
  ['céramique', 'ceramic'], ['porcelaine', 'porcelain'], ['marbre', 'marble'],
  ['granit', 'granite'], ['quartz', 'quartz'], ['ardoise', 'slate'],
  ['stratifié', 'laminate'], ['vinyle', 'vinyl'], ['bambou', 'bamboo'],
  ['liège', 'cork'], ['chêne', 'oak'], ['érable', 'maple'],
  ['bouleau', 'birch'], ['cerisier', 'cherry'], ['noyer', 'walnut'],
  ['cèdre', 'cedar'], ['pin', 'pine'], ['bois', 'wood'],
  ['peinture', 'paint'], ['apprêt', 'primer'], ['vernis', 'varnish'],
  ['teinture', 'stain'], ['pinceau', 'brush'], ['rouleau', 'roll'],
  ['plateau', 'tray'], ['bâche', 'tarp'], ['masquer', 'masking'],
  ['ruban', 'tape'], ['calfeutrant', 'caulk'], ['scellant', 'sealant'],
  ['enduit', 'compound'], ['adhésif', 'adhesive'], ['colle', 'glue'],
  ['mousse', 'foam'], ['uréthane', 'urethane'], ['polyuréthane', 'polyurethane'],
  ['acrylique', 'acrylic'], ['latex', 'latex'], ['huile', 'oil'],
  ['eau', 'water'], ['gaz', 'gas'], ['électrique', 'electric'],
  ['électricité', 'electrical'], ['plomberie', 'plumbing'],
  ['panneau', 'panel'], ['disjoncteur', 'breaker'], ['câble', 'cable'],
  ['boîte', 'box'], ['prise', 'outlet'], ['interrupteur', 'switch'],
  ['gradateur', 'dimmer'], ['plaque', 'plate'], ['détecteur', 'detector'],
  ['luminaire', 'fixture'], ['plafonnier', 'ceiling light'],
  ['conduit', 'conduit'], ['fil', 'wire'], ['tuyau', 'pipe'],
  ['cuivre', 'copper'], ['acier', 'steel'], ['inox', 'stainless steel'],
  ['aluminium', 'aluminum'], ['fonte', 'cast iron'], ['laiton', 'brass'],
  ['plomb', 'lead'], ['fer', 'iron'], ['métal', 'metal'],
  ['métallique', 'metal'], ['galvanisé', 'galvanized'], ['galvanisés', 'galvanized'],
  ['coude', 'elbow'], ['té', 'tee'], ['réducteur', 'reducer'],
  ['bouchon', 'cap'], ['manchon', 'coupling'], ['valve', 'valve'],
  ['soupape', 'valve'], ['raccord', 'fitting'], ['joint', 'joint'],
  ['drain', 'drain'], ['pompe', 'pump'], ['filtre', 'filter'],
  ['soudure', 'solder'], ['téflon', 'Teflon'], ['mortier', 'mortar'],
  ['ciment', 'cement'], ['béton', 'concrete'], ['armature', 'rebar'],
  ['treillis', 'mesh'], ['coffrage', 'formwork'], ['fondation', 'foundation'],
  ['semelle', 'footing'], ['pieu', 'pile'], ['vissé', 'helical'],
  ['contreplaqué', 'plywood'], ['osb', 'OSB'], ['poutre', 'beam'],
  ['solive', 'joist'], ['étrier', 'hanger'], ['lisse', 'plate'],
  ['poteau', 'post'], ['ossature', 'framing'], ['charpente', 'framing'],
  ['charpenterie', 'framing'], ['toiture', 'roofing'], ['toit', 'roof'],
  ['bardage', 'siding'], ['parement', 'veneer'], ['brique', 'brick'],
  ['pierre', 'stone'], ['stucco', 'stucco'], ['fibrociment', 'fiber cement'],
  ['ardoise', 'slate'], ['tuile', 'tile'], ['carreau', 'tile'],
  ['carreaux', 'tiles'], ['mosaïque', 'mosaic'], ['dosseret', 'backsplash'],
  ['crédence', 'backsplash'], ['plinthe', 'baseboard'], ['plinthes', 'baseboards'],
  ['moulure', 'molding'], ['boiserie', 'trim'], ['boiseries', 'trim'],
  ['cadre', 'frame'], ['seuil', 'threshold'], ['quincaillerie', 'hardware'],
  ['poignée', 'handle'], ['serrure', 'lock'], ['charnière', 'hinge'],
  ['bouton', 'knob'], ['gypse', 'drywall'], ['placoplâtre', 'drywall'],
  ['isolant', 'insulation'], ['isolation', 'insulation'], ['laine', 'wool'],
  ['polystyrène', 'polystyrene'], ['cellulose', 'cellulose'],
  ['fenêtre', 'window'], ['porte', 'door'], ['escalier', 'staircase'],
  ['marche', 'step'], ['rampe', 'railing'], ['balustrade', 'balustrade'],
  ['terrasse', 'deck'], ['patio', 'patio'], ['balcon', 'balcony'],
  ['clôture', 'fence'], ['portail', 'gate'], ['barrière', 'gate'],
  ['arbre', 'tree'], ['arbuste', 'shrub'], ['vivace', 'perennial'],
  ['conifère', 'conifer'], ['haie', 'hedge'],
  ['tourbe', 'sod'], ['terre', 'soil'], ['gazon', 'lawn'],
  ['paillis', 'mulch'], ['compost', 'compost'], ['engrais', 'fertilizer'],
  ['sable', 'sand'], ['gravier', 'gravel'], ['galet', 'pebble'],
  ['pavé', 'paver'], ['dalle', 'slab'], ['bordure', 'edging'],
  ['mur', 'wall'], ['bassin', 'basin'], ['fontaine', 'fountain'],
  ['conteneur', 'dumpster'], ['marteau-piqueur', 'jackhammer'],
  ['marteau', 'hammer'], ['scie', 'saw'], ['lame', 'blade'],
  ['disque', 'disc'], ['pic', 'pickaxe'], ['barre', 'bar'],
  ['pelle', 'shovel'], ['brouette', 'wheelbarrow'], ['aspirateur', 'vacuum'],
  ['masque', 'mask'], ['gants', 'gloves'], ['lunettes', 'glasses'],
  ['casque', 'helmet'], ['bottes', 'boots'], ['paire', 'pair'],
  ['harnais', 'harness'], ['échafaudage', 'scaffolding'],
  ['permis', 'permit'], ['plan', 'plan'], ['plans', 'plans'],
  ['arpentage', 'survey'], ['excavation', 'excavation'],
  ['pelle mécanique', 'excavator'], ['camion', 'truck'],
  ['thermopompe', 'heat pump'], ['climatiseur', 'air conditioner'],
  ['climatisation', 'air conditioning'], ['échangeur', 'exchanger'],
  ['ventilateur', 'fan'], ['grille', 'grille'], ['diffuseur', 'diffuser'],
  ['thermostat', 'thermostat'], ['fournaise', 'furnace'],
  ['chauffage', 'heating'], ['radiateur', 'radiator'],
  ['boiler', 'boiler'], ['chaudière', 'boiler'],
  ['sécheuse', 'dryer'], ['lave-linge', 'washer'], ['laveuse', 'washer'],
  ['lave-vaisselle', 'dishwasher'], ['cuisinière', 'range'],
  ['four', 'oven'], ['micro-ondes', 'microwave'],
  ['réfrigérateur', 'refrigerator'], ['congélateur', 'freezer'],
  ['hotte', 'range hood'], ['îlot', 'island'], ['tabouret', 'stool'],
  ['tablette', 'shelf'], ['étagère', 'shelf'], ['rangement', 'storage'],
  ['placard', 'closet'], ['penderie', 'wardrobe'],
  ['échafaudage', 'scaffolding'], ['location', 'rental'],
  ['service', 'service'], ['entretien', 'maintenance'],
  ['installation', 'installation'], ['démolition', 'demolition'],
  ['rénovation', 'renovation'], ['agrandissement', 'extension'],
  ['paysagement', 'landscaping'], ['terrassement', 'earthworks'],
  ['drainage', 'drainage'], ['imperméabilisation', 'waterproofing'],

  // === Adjectives & qualifiers ===
  ['standard', 'standard'], ['premium', 'premium'], ['économique', 'economy'],
  ['intelligent', 'smart'], ['intelligente', 'smart'],
  ['silencieux', 'quiet'], ['silencieuse', 'quiet'],
  ['portable', 'portable'], ['portatif', 'portable'],
  ['suspendu', 'hanging'], ['suspendue', 'hanging'],
  ['encastré', 'recessed'], ['encastrée', 'recessed'],
  ['mural', 'wall-mounted'], ['murale', 'wall-mounted'],
  ['sur mesure', 'custom'], ['fait sur mesure', 'custom-made'],
  ['flottant', 'floating'], ['flottante', 'floating'],
  ['autoportant', 'freestanding'], ['autoportante', 'freestanding'],
  ['allongée', 'elongated'], ['ronde', 'round'], ['rond', 'round'],
  ['rectangulaire', 'rectangular'], ['carrée', 'square'], ['ovale', 'oval'],
  ['simple', 'single'], ['double', 'double'], ['triple', 'triple'],
  ['traité', 'treated'], ['traités', 'treated'], ['traitée', 'treated'], ['traitées', 'treated'],
  ['naturel', 'natural'], ['naturelle', 'natural'],
  ['rouge', 'red'], ['blanc', 'white'], ['blanche', 'white'],
  ['noir', 'black'], ['noire', 'black'], ['gris', 'gray'],
  ['grise', 'gray'], ['vert', 'green'], ['verte', 'green'],
  ['bleu', 'blue'], ['bleue', 'blue'], ['jaune', 'yellow'],
  ['violet', 'purple'], ['violette', 'purple'], ['orange', 'orange'],
  ['brun', 'brown'], ['brune', 'brown'],
  ['petit', 'small'], ['petite', 'small'], ['grand', 'large'], ['grande', 'large'],
  ['neuf', 'new'], ['neuve', 'new'], ['vieux', 'old'], ['vieille', 'old'],
  ['haut', 'high'], ['haute', 'high'], ['bas', 'low'], ['basse', 'low'],
  ['intérieur', 'interior'], ['intérieure', 'interior'],
  ['extérieur', 'exterior'], ['extérieure', 'exterior'],
  ['résidentiel', 'residential'], ['résidentielle', 'residential'],
  ['commercial', 'commercial'], ['commerciale', 'commercial'],
  ['industriel', 'industrial'], ['industrielle', 'industrial'],
  ['ornemental', 'ornamental'], ['ornementale', 'ornamental'],
  ['décoratif', 'decorative'], ['décorative', 'decorative'],
  ['flexible', 'flexible'], ['rigide', 'rigid'],
  ['étanche', 'waterproof'], ['hydrofuge', 'water-repellent'],
  ['isolé', 'insulated'], ['isolée', 'insulated'],
  ['chauffant', 'heated'], ['chauffante', 'heated'],
  ['refroidi', 'cooled'], ['refroidie', 'cooled'],
  ['lavable', 'washable'], ['résistant', 'resistant'], ['résistante', 'resistant'],
  ['perforé', 'perforated'], ['perforée', 'perforated'],
  ['plein', 'solid'], ['pleine', 'solid'], ['massif', 'solid'],
  ['ajouré', 'open-web'], ['ajourée', 'open-web'],
  ['profilé', 'profiled'], ['profilée', 'profiled'],
  ['préformé', 'preformed'], ['préformée', 'preformed'],
  ['prémélangé', 'pre-mixed'], ['prémélangée', 'pre-mixed'],
  ['préfabriqué', 'prefabricated'], ['préfabriquée', 'prefabricated'],
  ['préfab', 'prefab'], ['préfa', 'prefab'],
  ['prélaqué', 'pre-painted'], ['prélaquée', 'pre-painted'],
  ['prépeint', 'pre-painted'], ['prépeinte', 'pre-painted'],
  ['installé', 'installed'], ['installée', 'installed'],
  ['posé', 'installed'], ['posée', 'installed'],
  ['clé en main', 'turn-key'], ['main d\'œuvre', 'labor'],
  ['main-d\'œuvre', 'labor'], ['main d\'oeuvre', 'labor'],
  ['équipement', 'equipment'], ['outil', 'tool'], ['outils', 'tools'],
  ['matériel', 'material'], ['matériau', 'material'], ['matériaux', 'materials'],
  ['fini', 'finish'], ['finition', 'finish'],
  ['couche', 'coat'], ['scellée', 'sealed'],
  ['lustré', 'gloss'], ['mat', 'matte'], ['mate', 'matte'],
  ['perle', 'pearl'], ['coquille', 'shell'],
  ['acoustique', 'acoustic'],
  ['anti-tâches', 'stain-blocking'], ['antitaches', 'stain-resistant'],
  ['anti-retour', 'check'], ['antigel', 'frost-free'],
  ['anti-bruit', 'noise-cancelling'], ['antibruit', 'noise-cancelling'],
  ['à fermeture lente', 'soft-close'], ['à coller', 'glue-down'],
  ['à eau', 'water-based'], ['à huile', 'oil-based'],
  ['à clouer', 'nail-on'], ['à visser', 'screw-on'],
  ['à coller', 'glue-down'], ['à incliner', 'tilt-out'],
  ['à fermeture douce', 'soft-close'],
  ['au sol', 'floor'], ['au pied', 'base'], ['au gaz', 'gas'],
  ['au plafond', 'ceiling'], ['au mur', 'wall'],
  ['par bouilloire', 'pot filler'], ['par région', 'by region'],

  // === Connectors / prepositions ===
  ['avec', 'with'], ['sans', 'without'], ['pour', 'for'],
  ['dans', 'in'], ['sur', 'on'], ['sous', 'under'], ['par', 'by'],
  ['vers', 'toward'], ['entre', 'between'], ['et', 'and'], ['ou', 'or'],
  ['de', 'of'], ['du', 'of the'], ['des', 'of the'], ['des', 'of the'],
  ['la', ''], ['le', ''], ['les', ''], ['un', 'a'], ['une', 'a'],

  // === Misc / common ===
  ['à déduire', 'deductible'], ['à estimer', 'to be estimated'],
  ['estimé', 'estimated'], ['estimée', 'estimated'],
  ['réglable', 'adjustable'], ['lumières', 'lights'], ['lumière', 'light'],
  ['sécurité', 'safety'], ['portative', 'portable'], ['portatif', 'portable'],
  ['câbles', 'cables'], ['réfection', 'repair'],
  ['systèmes', 'systems'], ['système', 'system'],
  ['manufacturée', 'manufactured'], ['manufacturé', 'manufactured'],
  ['préparation', 'preparation'], ['préparations', 'preparations'],
  ['décor', 'decor'], ['étapes', 'stages'], ['étape', 'stage'],
  ['trappe d\'accès', 'access hatch'], ['trappe', 'hatch'],
  ['rainuré', 'tongue-and-groove'], ['rainurée', 'tongue-and-groove'],
  ['coulé', 'poured'], ['coulée', 'poured'], ['coulés', 'poured'],
  ['périphérique', 'perimeter'], ['calibré', 'caliper'],
  ['assemblée', 'assembled'], ['assemblé', 'assembled'],
  ['goutte-à-goutte', 'drip'], ['goutte à goutte', 'drip'],
  ['personnalisé', 'custom'], ['personnalisée', 'custom'],
  ['tranchée', 'trench'], ['régulier', 'regular'], ['régulière', 'regular'],
  ['neuf', 'new'], ['neuve', 'new'],
  ['tonnes', 'tons'], ['tonne', 'ton'],
  ['chambres', 'chambers'], ['chambre', 'chamber'],
  ['fond.', 'fdn.'],
  ['pi.²', 'sq.ft'], ['pi.lin.', 'lin.ft'], ['pi lin', 'lin.ft'],
  ['vg.³', 'cu.yd'], ['vg.²', 'sq.yd'],
  ['matériau personnalisé', 'custom material'],
  ['item personnalisé', 'custom item'],
  ['en acrylique', 'in acrylic'], ['en acier', 'in steel'],
  ['en aluminium', 'in aluminum'], ['en céramique', 'in ceramic'],
  ['en porcelaine', 'in porcelain'], ['en marbre', 'in marble'],
  ['en bois', 'in wood'], ['en métal', 'in metal'],
  ['en granit', 'in granite'], ['en cuivre', 'in copper'],
  ['en verre', 'in glass'], ['en vinyle', 'in vinyl'],
  ['en pin traité', 'in treated pine'],
  ['en pin', 'in pine'],
  ['en cèdre', 'in cedar'],
  ['en plastique', 'in plastic'],
  ['en pierre', 'in stone'],
  ['en fibre de verre', 'in fiberglass'],
  ['en fibre', 'in fiber'],
  ['cédulaire', 'schedule'],
  ['plastique', 'plastic'], ['octogonale', 'octagonal'], ['octogonal', 'octagonal'],
  ['parois', 'walls'], ['paroi', 'wall'],
  ['réservoir', 'tank'],
  ['pôle', 'pole'], ['pôles', 'poles'],
  ['3-pattes', '3-tab'], ['3 pattes', '3-tab'],
  ['à 3 pattes', '3-tab'],
  ['à pression', 'pressure'],
  ['écologique', 'eco-friendly'], ['recyclé', 'recycled'], ['recyclée', 'recycled'],
  ['à toiture', 'roofing'],
  ['toitures', 'roofs'],
  ['installations', 'installations'],
  ['installation', 'installation'],
  ['amovible', 'removable'], ['fixe', 'fixed'],
  ['rétractable', 'retractable'], ['extensible', 'extendable'],
  ['motorisé', 'motorized'], ['motorisée', 'motorized'],
  ['automatique', 'automatic'], ['manuel', 'manual'], ['manuelle', 'manual'],
  ['à minuterie', 'timer'], ['minuterie', 'timer'],
  ['à distance', 'remote'], ['télécommande', 'remote'],
  ['propre', 'own'], ['propres', 'own'],
  ['principal', 'main'], ['principale', 'main'],
  ['secondaire', 'secondary'], ['auxiliaire', 'auxiliary'],
  ['primaire', 'primary'],
  ['classique', 'classic'], ['moderne', 'modern'],
  ['contemporain', 'contemporary'], ['contemporaine', 'contemporary'],
  ['traditionnel', 'traditional'], ['traditionnelle', 'traditional'],
  ['rustique', 'rustic'],
  ['lourd', 'heavy'], ['lourde', 'heavy'], ['léger', 'light'], ['légère', 'light'],
  ['rapide', 'fast'], ['lent', 'slow'], ['lente', 'slow'],
  ['fin', 'fine'], ['fine', 'fine'], ['épais', 'thick'], ['épaisse', 'thick'],
  ['long', 'long'], ['longue', 'long'], ['court', 'short'], ['courte', 'short'],
  ['large', 'wide'], ['étroit', 'narrow'], ['étroite', 'narrow'],
  ['profond', 'deep'], ['profonde', 'deep'],
  ['poli', 'polished'], ['polie', 'polished'], ['brossé', 'brushed'], ['brossée', 'brushed'],
  ['mat', 'matte'], ['mate', 'matte'],
  ['vieux bardeaux', 'old shingles'],
  ['vieux', 'old'], ['vieille', 'old'],
  ['feu', 'fire'], ['anti-feu', 'fireproof'],
  ['fumée', 'smoke'], ['oxyde de carbone', 'carbon monoxide'],
  ['monoxyde', 'monoxide'],
  ['cuisson', 'cooking'], ['cuisinière', 'range'],
  ['bain et douche', 'bath and shower'],
  ['à clouer', 'nail-on'],

  // === Adverbs / other ===
  ['bientôt', 'soon'], ['déjà', 'already'], ['jamais', 'never'],
  ['toujours', 'always'], ['parfois', 'sometimes'],
  ['très', 'very'],
  ['encore', 'again'], ['aussi', 'also'],
  // Note: deliberately NOT translating 'plus' / 'moins' to avoid breaking
  // brand names ("P Plus") and dimensions ("plus de 60 mois").
  ['entrée de gamme', 'entry-level'],
  ['haut de gamme', 'high-end'], ['bas de gamme', 'low-end'],
  ['gamme', 'range'],
  ['gallons', 'gallons'], ['gallon', 'gallon'],
  ['ans', 'years'], ['an', 'year'], ['mois', 'months'],
  ['semaine', 'week'], ['semaines', 'weeks'],
  ['jour', 'day'], ['jours', 'days'], ['heure', 'hour'], ['heures', 'hours'],
  ['kit', 'kit'], ['lot', 'lot'], ['paquet', 'pack'],
  ['boîte', 'box'], ['sac', 'bag'], ['sacs', 'bags'],
  ['tube', 'tube'], ['pot', 'pot'], ['seau', 'pail'],
  ['rouleau', 'roll'], ['feuille', 'sheet'], ['tonne', 'ton'],
  ['caissette', 'tray'], ['balle', 'bale'], ['zone', 'zone'],
  ['palette', 'pallet'], ['mètre', 'meter'], ['litre', 'liter'],
  ['kilo', 'kilo'], ['caisse', 'case'],
];

// Cap-insensitive find-and-replace that PRESERVES the original case for
// segments that aren't in the dictionary (so unit codes like 200A, 24V,
// 7000W, 12000 BTU stay untouched).
// We sort phrases by length DESC so longer expressions are replaced first,
// preventing single-word rules from breaking multi-word matches.
const SORTED_PHRASE_MAP = [...EN_PHRASE_MAP].sort((a, b) => b[0].length - a[0].length);

// Exact-name English overrides — guarantees natural professional trade terms
// (checked before the word-by-word dictionary). Catalog data only.
const EN_NAME_OVERRIDES = {
  'Armoire mélamine standard': 'Standard melamine cabinet',
  'Caisson d\'armoire bas (cabinet)': 'Base cabinet box',
  'Bardage de cèdre (clins)': 'Cedar clapboard siding',
  'Évier de ferme (apron) 30"': '30" farmhouse apron sink',
  'Miroir intelligent antibuée': 'Smart anti-fog mirror',
  'Évent de toit Maximum': 'Maximum roof vent',
  'Prise de plancher garage (pieuvre)': 'Garage floor outlet box',
  'Commutateur de transfert automatique': 'Automatic transfer switch',
  'Pompe de puisard 1/3 HP': 'Sump pump 1/3 HP',
  'Sertisseuse PEX (outil)': 'PEX crimping tool',
  'Panneau acoustique SONOpan': 'SONOpan acoustic panel',
  'Demi-masque P100': 'P100 half-face respirator',
  'Poubelle coulissante double': 'Pull-out double trash bin',
  'Coulisses pleine extension (paire)': 'Full-extension drawer slides (pair)',
  'Panneau de finition d\'îlot': 'Island finishing panel',
  'Évier de bar': 'Bar sink',
  'Robinet cuisine noir mat': 'Matte black kitchen faucet',
  'Comptoir porcelaine (Dekton)': 'Porcelain countertop (Dekton)',
  'Organisateur d\'ustensiles en bois': 'Wooden utensil organizer',
  'Pattes d\'armoire réglables (lot 4)': 'Adjustable cabinet legs (set of 4)',
  'Valve d\'eau pour réfrigérateur': 'Refrigerator water valve',
  'Moulure de caisson (fileur)': 'Cabinet filler strip',
  'Colonne de douche complète': 'Complete shower column',
  'Ensemble bain-douche 60"': '60" tub-shower combo',
  'Siège de douche rabattable': 'Fold-down shower seat',
  'Renvoi et trop-plein de bain': 'Bathtub drain and overflow kit',
  'Céramique murale métro 3x6': '3x6 subway wall tile',
  'Robinet lavabo cascade': 'Waterfall sink faucet',
  'Toilette compacte (10" rough-in)': 'Compact toilet (10" rough-in)',
  'Calfeutrant anti-moisissure salle de bain': 'Mold-resistant bathroom caulking',
  'Drain de lavabo avec bouchon': 'Sink drain with stopper',
  'Cadre de miroir sur mesure': 'Custom mirror frame',
  'Bardeau de départ (rouleau)': 'Starter shingle (roll)',
  'Bardeau de faîte': 'Ridge cap shingles',
  'Turbine de ventilation de toit': 'Roof ventilation turbine',
  'Solin de puits de lumière': 'Skylight flashing kit',
  'Puits de lumière fixe 2x4': 'Fixed skylight 2x4',
  'Planche de rive 1x8': '1x8 rake board',
  'Ancrage de sécurité de toit': 'Roof safety anchor',
  'Membrane de sous-toiture ventilée': 'Vented roof underlayment',
  'Moulure de départ vinyle': 'Vinyl starter strip',
  'Linteau de fenêtre aluminium': 'Aluminum window lintel',
  'Allège de fenêtre (solin)': 'Window sill flashing',
  'Bloc de montage luminaire/prise': 'Light/outlet mounting block',
  'Panneau LP SmartSide': 'LP SmartSide panel',
  'Crépi de fondation (sac)': 'Foundation parging mix (bag)',
  'Moustiquaire de soffite': 'Soffit screen roll',
  'Fourrure métallique 7/8"': '7/8" metal furring channel',
  'Autolissant (sac 25 kg)': 'Self-leveling underlayment (25 kg bag)',
  'Apprêt pour autolissant': 'Self-leveler primer',
  'Agrafes à plancher 18GA (boîte)': '18GA flooring staples (box)',
  'Nez de marche assorti': 'Matching stair nosing',
  'Scellant à coulis': 'Grout sealer',
  'Grattage de colle (par pi²)': 'Glue removal (per sq.ft)',
  'Tuiles de garage PVC clipsables': 'Interlocking PVC garage tiles',
  'Contremarche en pin': 'Pine stair riser',
  'Perche télescopique 4\'': '4\' telescopic extension pole',
  'Escabeau 6\' fibre de verre': '6\' fiberglass stepladder',
  'Pistolet airless (location/jour)': 'Airless sprayer (rental/day)',
  'Enduit texturé pour plafond': 'Textured ceiling coating',
  'Rouleau à coin 4"': '4" corner roller',
  'Filtre à peinture (paquet)': 'Paint strainers (pack)',
  'Mélangeur à peinture pour perceuse': 'Drill paint mixer',
  'Peinture tableau noir 1L': 'Chalkboard paint 1L',
  'Plinthe électrique 1000W': '1000W baseboard heater',
  'Plinthe électrique 1500W': '1500W baseboard heater',
  'Thermostat électronique de plinthe': 'Electronic baseboard thermostat',
  'Interrupteur minuterie': 'Timer switch',
  'Boîte de dérivation avec couvercle': 'Junction box with cover',
  'Fouet de cuisinière 50A': '50A range whip',
  'Luminaire DEL 4\' d\'atelier': '4\' LED shop light',
  'Détecteur d\'inondation intelligent': 'Smart water leak detector',
  'Clapet antiretour d\'égout 4"': '4" sewer backwater valve',
  'Bride de toilette 3"': '3" toilet flange',
  'Boîte de laveuse encastrée': 'Recessed washing machine outlet box',
  'Robinets de laveuse duo': 'Dual laundry faucet valves',
  'Siphon de lavabo chromé 1¼"': '1¼" chrome sink P-trap',
  'Flexible tressé inox 3/8" (paire)': '3/8" braided stainless supply lines (pair)',
  'Pompe de puisard de secours à eau': 'Water-powered backup sump pump',
  'Anneau de cire avec bride': 'Wax ring with flange',
  'Poteau ajustable en acier (télépost)': 'Adjustable steel post (telepost)',
  'Linteau d\'acier 3½" x 6\'': '3½" x 6\' steel lintel',
  'Colle à sous-plancher PL400': 'PL400 subfloor adhesive',
  'Cales de bois (shims) paquet': 'Wood shims (pack)',
  'Fourrure métallique 7/8" x 12\'': '7/8" x 12\' metal furring',
  'Bande résiliente insonorisante': 'Resilient soundproofing channel',
  'Profilé Z galvanisé': 'Galvanized Z-bar',
  'Connecteur de solive invisible': 'Concealed joist connector',
  'Accélérateur de prise (chlorure de calcium)': 'Set accelerator (calcium chloride)',
  'Composé de cure à béton': 'Concrete curing compound',
  'Kit d\'injection époxy pour fissures': 'Epoxy crack injection kit',
  'Ancrage béton Tapcon 1/4" (boîte 100)': '1/4" Tapcon concrete anchors (box of 100)',
  'Pigment colorant pour béton': 'Concrete color pigment',
  'Imperméabilisant cristallin (Xypex)': 'Crystalline waterproofing (Xypex)',
  'Treillis en fibre de verre': 'Fiberglass mesh roll',
  'Scellant à fissures de béton': 'Concrete crack sealant',
  'Gazon synthétique': 'Synthetic turf',
  'Marches de pierre naturelle': 'Natural stone steps',
  'Muret de pierre naturelle': 'Natural stone garden wall',
  'Foyer extérieur en blocs (kit)': 'Outdoor block fire pit (kit)',
  'Éclairage solaire d\'allée (lot 8)': 'Solar pathway lights (set of 8)',
  'Terre tamisée (verge cube)': 'Screened topsoil (cubic yard)',
  'Capteur de pluie pour irrigation': 'Rain sensor for irrigation',
  'Bordure de béton coulée': 'Poured concrete curb',
  'Décontamination amiante (sous-traitance)': 'Asbestos abatement (subcontracted)',
  'Abat-poussière (barrière ZipWall)': 'Dust barrier (ZipWall kit)',
  'Ventilateur négatif HEPA (location)': 'Negative air HEPA machine (rental)',
  'Polythène ignifuge (rouleau)': 'Fire-retardant poly sheeting (roll)',
  'Permis d\'occupation pour conteneur (rue)': 'Street container occupancy permit',
  'Protection d\'escalier en feutre': 'Stair protection felt roll',
  'Membrane insonorisante de plancher': 'Floor soundproofing membrane',
  'Échangeur d\'air VRC installé': 'Installed HRV air exchanger',
  'Escalier extérieur en béton préfab': 'Precast concrete exterior steps',
  'Seuil de porte extérieure aluminium': 'Exterior aluminum door threshold',
  'Solin de porte-patio': 'Patio door flashing kit',
  'Poutrelle ajourée installée': 'Installed open-web floor joist',
  'Fournaise électrique 15 kW': '15 kW electric furnace',
  'Fournaise électrique 20 kW': '20 kW electric furnace',
  'Thermopompe multi-zones 2 têtes': 'Dual-zone multi-split heat pump',
  'Plénum de fournaise sur mesure': 'Custom furnace plenum',
  'Humidificateur central': 'Whole-home humidifier',
  'Nettoyage de conduits (service)': 'Duct cleaning (service)',
  'Laine soufflée de verre R-40 grenier': 'Blown-in fiberglass attic insulation R-40',
  'Scellage portes et fenêtres à l\'uréthane': 'Door and window urethane air sealing',
  'Isolation des solives de rive à l\'uréthane': 'Rim joist urethane insulation',
  'Natte insonorisante (rouleau)': 'Soundproofing mat (roll)',
  'Laine de verre R-24 murs 2x6': 'R-24 fiberglass batts for 2x6 walls',
  'Pare-vapeur intelligent (MemBrain)': 'Smart vapor barrier (MemBrain)',
  'Pierre nette 3/4" (tonne)': '3/4" clear crushed stone (ton)',
  'Sable compactable (tonne)': 'Compactable sand (ton)',
  'Puisard extérieur avec grille': 'Exterior catch basin with grate',
  'Nivellement final du terrain': 'Final grading',
  'Membrane géotextile pour bassin': 'Pond geotextile liner',
  'Bloc de patio (deck block)': 'Deck block',
  'Lisse d\'ancrage au mur (ledger) 2x10': '2x10 ledger board',
  'Jupe de terrasse (treillis)': 'Deck skirting lattice',
  'Limon d\'escalier 4 marches': '4-step stair stringer',
  'Teinture à terrasse (gallon)': 'Deck stain (gallon)',
  'Luminaire de poteau solaire': 'Solar post cap light',
  'Drain de garage avec grille': 'Garage floor drain with grate',
  'Seuil de porte de garage en caoutchouc': 'Rubber garage door threshold',
  'Panneau slatwall PVC 4x8': '4x8 PVC slatwall panel',
  'Support à vélos au plafond': 'Ceiling bike hoist',
  'Peinture de lignes de stationnement': 'Parking line paint',
};

function translateEN(name) {
  if (!name) return name;
  if (EN_NAME_OVERRIDES[name]) return EN_NAME_OVERRIDES[name];
  let s = name;
  for (const [fr, en] of SORTED_PHRASE_MAP) {
    if (!fr) continue;
    const escaped = fr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // Word-boundary regex tolerant of French diacritics; case-insensitive.
    const re = new RegExp(`(^|[^a-zA-Zà-ÿÀ-ß])${escaped}(?=[^a-zA-Zà-ÿÀ-ß]|$)`, 'gi');
    s = s.replace(re, (_, pre) => pre + en);
  }
  // Collapse double spaces (from removed connectors like "de", "la").
  s = s.replace(/\s+/g, ' ').trim();
  // Capitalize first character.
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function buildEN() {
  const out = {};
  for (const [frKey, items] of Object.entries(FR)) {
    const enKey = EN_MAP_KEYS[frKey] || frKey;
    out[enKey] = items.map((it) => ({
      name: translateEN(it.name),
      unit: EN_TRANSLATIONS[it.unit] || it.unit,
      price: it.price,
    }));
  }
  return out;
}

// Merge extras into FR (additions per work type + new work types)
import { FR_EXTRAS, EN_EXTRA_KEYS } from './materialsCatalogExtras';
for (const [wt, items] of Object.entries(FR_EXTRAS)) {
  FR[wt] = [...(FR[wt] || []), ...items];
}
// Merge EN keys for new categories
for (const [frKey, enKey] of Object.entries(EN_EXTRA_KEYS)) {
  EN_MAP_KEYS[frKey] = enKey;
}

// Cross-language workType normalization map.
// When the workType label is in FR but the catalog is requested in EN
// (or vice-versa), this lets us still find the right item set.
const WORK_TYPE_BIDIRECTIONAL = {};
for (const [frKey, enKey] of Object.entries(EN_MAP_KEYS)) {
  WORK_TYPE_BIDIRECTIONAL[frKey] = enKey;
  WORK_TYPE_BIDIRECTIONAL[enKey] = frKey;
}

export const MATERIALS_CATALOG = { fr: FR, en: buildEN() };
export const ALL_UNITS = {
  fr: ['un', 'pi.lin.', 'pi.²', 'pi.³', 'vg.²', 'vg.³', 'pied linéaire', 'm.²', 'm.³', 'mètre', 'paquet', 'rouleau', 'feuille', 'sac', 'tonne', 'gallon', 'litre', 'lb', 'kg', 'tube', 'pot', 'seau', 'lot', 'boîte', 'caissette', 'balle', 'paire', 'zone', 'marche', 'kit', 'heure', 'jour'],
  en: ['unit', 'lin.ft', 'sq.ft', 'cu.ft', 'sq.yd', 'cu.yd', 'linear foot', 'sq.m', 'cu.m', 'meter', 'bundle', 'roll', 'sheet', 'bag', 'ton', 'gallon', 'liter', 'lb', 'kg', 'tube', 'pot', 'pail', 'set', 'box', 'tray', 'bale', 'pair', 'zone', 'step', 'kit', 'hour', 'day'],
};

export function getCatalogFor(workType, lang = 'fr') {
  const dict = MATERIALS_CATALOG[lang] || MATERIALS_CATALOG.fr;
  if (!workType) {
    return dict[lang === 'fr' ? 'Autre' : 'Other'] || [];
  }
  // First, direct hit in the requested language.
  if (dict[workType]) return dict[workType];
  // Try cross-language: e.g. workType = 'Rénovation cuisine' but lang = 'en'.
  const alternate = WORK_TYPE_BIDIRECTIONAL[workType];
  if (alternate && dict[alternate]) return dict[alternate];
  // Last resort: case-insensitive search across the requested dict.
  const lowered = workType.toLowerCase();
  for (const key of Object.keys(dict)) {
    if (key.toLowerCase() === lowered) return dict[key];
  }
  return dict[lang === 'fr' ? 'Autre' : 'Other'] || [];
}

export function getUnitsFor(workType, lang = 'fr') {
  const items = getCatalogFor(workType, lang);
  const units = new Set(items.map((i) => i.unit));
  (ALL_UNITS[lang] || ALL_UNITS.fr).forEach((u) => units.add(u));
  return Array.from(units);
}
